/* eslint-disable autofix/no-unused-vars */
export enum ITISCodes {
    // Accidents
    Accident = 513, // Use when no further data is available regarding involved vehicle type
    SeriousAccident = 514,
    InjuryAccident = 515,
    MinorAccident = 516,
    MultiVehicleAccident = 517, // To be used when events are NOT distributed along a road segment (i.e., one location)
    NumerousAccidents = 518, // To be used when events are distributed along a road segment
    AccidentInvolvingABicycle = 519,
    AccidentInvolvingABus = 520,
    AccidentInvolvingAMotorcycle = 521,
    AccidentInvolvingAPedestrian = 522,
    AccidentInvolvingATrain = 523,
    AccidentInvolvingATruck = 524,
    AccidentInvolvingASemiTrailer = 562,
    AccidentInvolvingHazardousMaterials = 525,
    EarlierAccident = 526, // Hint: Typically used as a cause, as with “Due to”
    MedicalEmergency = 527,
    SecondaryAccident = 528,
    // Removed, use Rescue and recovery work in progress in the Incident Response Status group when needed
    RescueAndRecoveryWorkRemoved = 529,
    AccidentInvestigationWork = 530,
    Incident = 531, // Hint: For non-accident incidents (disabled, police pull over, etc.) where no further information is available
    // Disabled, etc.
    StalledVehicle = 532,
    AbandonedVehicle = 533,
    DisabledVehicle = 534,
    DisabledTruck = 535,
    DisabledSemiTrailer = 536, // Alternative Rendering: disabled tractor-trailer
    DisabledBus = 537,
    DisabledTrain = 538,
    VehicleSpunOut = 539,
    VehicleOnFire = 540,
    VehicleInWater = 541,
    VehiclesSlowingToLookAtAccident = 542, // Alternative Rendering: On-looker slowdown, Rubbernecking
    // Jackknifed
    JackknifedSemiTrailer = 543, // Alternatives can use: jackknifed tractor-trailer, jackknifed truck, jackknifed big-rig
    JackknifedTrailerHome = 544,
    JackknifedTrailer = 545, // Hint: Used for smaller trailers (i.e., not type “jackknifed semi trailer” above)
    // Spills
    SpillageOccurringFromMovingVehicle = 546,
    AcidSpill = 547,
    ChemicalSpill = 548,
    FuelSpill = 549,
    HazardousMaterialsSpill = 550, // Also use the Disaster lists for large HAZMAT events
    OilSpill = 551,
    SpilledLoad = 552,
    ToxicSpill = 553,
    // Overturned. Stuck
    OverturnedVehicle = 554, // Use when no further data is available regarding involved vehicle types
    OverturnedTruck = 555,
    OverturnedSemiTrailer = 556,
    OverturnedBus = 557,
    DerailedTrain = 558,
    StuckVehicle = 559, // It is preferred to provide data which denotes WHY the vehicle is stuck (i.e., mud/snow, under bridge, too wide, etc.)
    TruckStuckUnderBridge = 560, // Alternative Rendering: high load hit involving truck
    BusStuckUnderBridge = 561, // Alternative Rendering: high load hit involving bus
    // Cancel Types
    AccidentCleared = 638,
    IncidentCleared = 639,
    DetourWherePossible = 8449,
    // AlternateRoute
    NoDetourAvailable = 8450,
    FollowSigns = 8451,
    FollowDetourSigns = 8452,
    FollowSpecialDetourMarkers = 8453,
    DoNotFollowDetourSigns = 8454,
    DetourInOperation = 8455,
    FollowLocalDetour = 8456,
    CompulsoryDetourInOperation = 8457,
    NoSuitableDetourAvailable = 8458,
    DetourIsNoLongerRecommended = 8459,
    LocalDriversAreRecommendedToAvoidTheArea = 8460,
    TrucksAreRecommendedToAvoidTheArea = 8461,
    ConsiderAlternateRoute = 8462,
    ConsiderAlternateParking = 8463,
    ConsiderAlternateDestination = 8464,
    ConsiderAlternateArea = 8465,
    // Specific Route Types
    SnowRoute = 8466,
    EmergencySnowRoute = 8467,
    EvacuationRoute = 8468, // May be preceded by a specific type, Used also for general emergency routes.
    TruckRoute = 8469,
    HazardousMaterialsRoute = 8470, // May be used with ‘any time’ for allowed, or ‘no’ for prohibited, or ‘detour’
    Detour = 8471,
    // Assets Status
    UnknownStatus = 10240, // Used when status is not known
    ReadyForUse = 10241,
    WorkingNormally = 10242,
    WorkingAutonomously = 10243,
    WorkingIncorrectly = 10244,
    NotWorking = 10245,
    NormalMaintenance = 10246,
    InRouteToUse = 10247,
    ReturningFromUse = 10248,
    OutOfService = 10249,
    OffDuty = 10250,
    OnPatrol = 10251,
    OnCall = 10252,
    OnBreak = 10253,
    MandatoryTimeOff = 10254,
    LowOnFuel = 10255,
    LowOnWater = 10256,
    LowCharge = 10257,
    Missing = 10258,
    // Closures
    ClosedToTraffic = 769, // Used for road-closed and variations
    Closed = 770, // Hint: use this only for NON road-lane items (such as a rest stop)
    ClosedAhead = 771,
    ClosedIntermittently = 772,
    ClosedForRepairs = 773,
    ClosedForTheSeason = 774,
    Blocked = 775,
    BlockedAhead = 776,
    ReducedToOneLane = 777,
    ReducedToTwoLanes = 778,
    ReducedToThreeLanes = 779,
    Collapse = 780, // Used with bridges and tunnels
    Out = 781, // Used with bridges and roads
    // Cancel Types
    OpenToTraffic = 891,
    Open = 892, // Hint: use this only for NON road-lane items (such as a rest stop)
    ReopenedToTraffic = 893,
    Clearing = 894,
    ClearedFromRoad = 895,
    // DelayStatusCancellation
    // Delays
    Delays = 1537,
    ShortDelays = 1538,
    LongDelays = 1539,
    VeryLongDelays = 1540,
    DelaysOfUncertainDuration = 1541,
    DelayedUntilFurtherNotice = 1542,
    Busy = 1543, // Hint: Combine with generic locations (station busy, etc.)
    VeryBusy = 1544,
    Crowded = 1545,
    Overcrowded = 1546,
    // Cancellations
    Cancellations = 1547,
    RouteCanceledAndNoReplacement = 1548,
    ServiceCanceled = 1549,
    ServiceSuspended = 1550,
    ServiceWithdrawn = 1551,
    ServiceFullyBooked = 1552,
    AllServicesFullyBooked = 1553,
    // Service Levels
    NextDeparture = 1554, // Typically followed by a time value
    NextArrival = 1555, // Typically followed by a # value of time
    VeryFrequentService = 1556,
    FrequentService = 1557,
    FairlyFrequentService = 1558,
    RegularService = 1559,
    IrregularService = 1560,
    NotOperating = 1561,
    // Other
    SystemBusy = 1562, // In this context “system” means the entire network of services over a wide area such as an airline system
    SystemVeryBusy = 1563,
    SystemCrowded = 1564,
    SystemOvercrowded = 1565,
    DeletedTravelTime = 1566, // A duplicate entry, now removed in favor of item 269
    Headway = 1567, // Typically followed by a # value of time
    ExtraServicesInOperation = 1568,
    // Cancel Types
    DelaysClearing = 1660,
    DelaysCleared = 1661,
    NormalServicesResumed = 1662,
    Operating = 1663,
    // Device Status
    LaneControlSignsNotWorking = 2305,
    LaneControlSignsWorkingIncorrectly = 2306,
    LaneControlSignsOperating = 2307,
    VariableMessageSignsNotWorking = 2308,
    VariableMessageSignsWorkingIncorrectly = 2309,
    VariableMessageSignsOperating = 2310,
    EmergencyTelephonesNotWorking = 2311,
    EmergencyTelephoneNumberNotWorking = 2312,
    TrafficLightsNotWorking = 2313,
    TrafficLightsWorkingIncorrectly = 2314,
    RampControlSignalsNotWorking = 2315,
    RampControlSignalsWorkingIncorrectly = 2316,
    TemporaryTrafficLightsNotWorking = 2317,
    TemporaryTrafficLightsWorkingIncorrectly = 2318,
    TrafficSignalControlComputerNotWorking = 2319,
    TrafficSignalTimingsChanged = 2320,
    OverheightWarningSystemTriggered = 2321,
    EquipmentFailure = 2322,
    RailroadCrossingEquipmentFailure = 2323,
    TunnelVentilationNotWorking = 2324,
    PowerFailure = 2325, // Hint: Use for localized cases of power loss
    WidespreadPowerOutages = 2326, // Alternative rendering: widespread power cuts
    TechnicalProblems = 2327,
    SignDown = 2328,
    LinesInRoadFaded = 2329,
    DamagedLightStandard = 2330, // Used for all forms of pole/support damage
    TrafficSignalStuckOnFlash = 2331,
    GuideRail = 2332, // Used for barriers as well
    Fencing = 2333,
    LightStandardHangingByWires = 2334,
    CallBox = 2335,
    SignalCabinet = 2336, // Use for all types of equipment cabinets
    Detector = 2337, // All forms of vehicle detectors
    ImproperUseOfStateVehicleOrEquipment = 2338,
    BulbOut = 2339,
    NotYetOperational = 2340, // When installed but not yet brought on-line for use by the system
    NotYetInstalled = 2341, // When planned
    // Cancel Types
    ElectronicSignsRepaired = 2428,
    EmergencyCallFacilitiesRestored = 2429,
    TrafficSignalsRepaired = 2430,
    RailroadCrossingEquipmentNowWorkingNormally = 2431,
    // Disasters
    // Water Related
    FlashFlood = 3073,
    MajorFlood = 3074,
    ReservoirFailure = 3075,
    LeveeFailure = 3076,
    Tsunami = 3077,
    TidalWave = 3078,
    // Fire Related
    VolcanicEruption = 3079,
    AshFall = 3080,
    LavaFlow = 3081,
    SeriousFire = 3082,
    ForestFire = 3083,
    Wildfire = 3084,
    BuildingFire = 3085,
    BrushFire = 3086,
    GrassFire = 3087,
    FireDangerExtreme = 3088,
    FireDangerVeryHigh = 3089,
    FireDangerHigh = 3090,
    FireDangerMedium = 3091,
    FireDangerLow = 3092,
    // Other
    EarthquakeDamage = 3093,
    AirCrash = 3094,
    RailCrash = 3095,
    ToxicRelease = 3096,
    ToxicLeak = 3097,
    RadioactiveRelease = 3098,
    RadiationHazard = 3099,
    ReactorLeakage = 3100,
    Explosion = 3101,
    MajorHazardousMaterialsFire = 3102, // Alternative Rendering: Major HAZMAT fire
    MajorHazardousMaterialsRelease = 3103, // Alternative Rendering: Major HAZMAT release
    // Cancel Types
    DisasterCleared = 3199,
    // Disturbances
    Assault = 3329, // This index is not to be used as a default value for this category
    Crime = 3330,
    Robbery = 3331,
    FareDispute = 3332,
    Shooting = 3333,
    GunfireOnRoadway = 3334,
    Suicide = 3335,
    Fight = 3336, // Involves a few persons and is localized (alt: brawl)
    GangFight = 3337, // Multi-party event occurring which may involve weapons
    PersonHarassment = 3338, // “person” may be rendered as “passenger” if used in a controlled environment such as transit
    PersonInjured = 3339,
    SickCustomer = 3363,
    UnrulyPassenger = 3340,
    PersonIntoxicated = 3341,
    CrowdControlProblem = 3342,
    Demonstration = 3343,
    March = 3344,
    PublicDisturbance = 3345,
    Riot = 3346,
    CivilUnrest = 3347,
    CivilEmergency = 3348,
    Strike = 3349,
    PublicTransitStrike = 3350, // Hint: Strike affecting services
    Stampede = 3351,
    TeargasUsed = 3352,
    SecurityAlert = 3353, // Heightened security procedures in effect
    SecurityIncident = 3354,
    Checkpoint = 3355,
    BombAlert = 3356,
    TerroristIncident = 3357,
    HighVelocityShellFire = 3358, // Hint: Used as a part of avalanche control
    ExplosivesInUse = 3359,
    AirRaid = 3360,
    WeaponsOfMassDestructionThreat = 3361,
    MilitaryOperations = 3362, // (war)
    // Cancel Types
    SecurityProblemCleared = 3454,
    TrafficDisturbanceCleared = 3455,
    // Generic Locations
    // Road Related
    OnBridges = 7937, // Not to be used as the default for this category
    InTunnels = 7938,
    EnteringOrLeavingTunnels = 7939,
    OnRamps = 7940,
    InRoadConstructionArea = 7941,
    AroundACurve = 7942,
    OnCurve = 8026,
    OnTracks = 8009,
    InStreet = 8025, // As in in-street pad crossing
    Shoulder = 8027,
    OnMinorRoads = 7943,
    InTheOpposingLanes = 7944,
    AdjacentToRoadway = 7945,
    AcrossTracks = 8024,
    OnBend = 7946,
    Intersection = 8032,
    EntireIntersection = 7947,
    InTheMedian = 7948,
    MovedToSideOfRoad = 7949,
    MovedToShoulder = 7950,
    OnTheRoadway = 7951, // Use generic locations and groups affected to make other such phrases
    Dip = 8010,
    TrafficCircle = 8011, // Used for W2-6 graphic as well. Alt term: roundabout
    Crossover = 8028,
    CrossRoad = 8029, // Also used for W2-1 Note that in some uses this is one word
    SideRoad = 8030, // Do not used for W2-2R and W2-2L
    To = 8014,
    By = 8015,
    Through = 8016,
    AreaOf = 8017, // Also area
    Under = 8018,
    Over = 8019,
    From = 8020,
    Approaching = 8021,
    EnteringAt = 8022, // Alt form: Entrance
    ExitingAt = 8023,
    // Terrain & Geography
    InShadedAreas = 7952,
    InLowLyingAreas = 7953,
    InTheDowntownArea = 7954,
    InTheInnerCityArea = 7955,
    InParts = 7956,
    InSomePlaces = 7957,
    InTheDitch = 7958,
    InTheValley = 7959,
    OnHillTop = 7960,
    NearTheFoothills = 7961,
    AtHighAltitudes = 7962,
    NearTheLake = 7963,
    NearTheShore = 7964,
    NearbyBasin = 8008,
    OverTheCrestOfAHill = 7965,
    OtherThanOnTheRoadway = 7966,
    NearTheBeach = 7967,
    NearBeachAccessPoint = 7968,
    MountainPass = 8006,
    LowerLevel = 7969,
    UpperLevel = 7970,
    Coast = 8034,
    // Transit Travel, Air Travel and Places
    Airport = 7971,
    Concourse = 7972,
    Gate = 7973,
    BaggageClaim = 7974,
    CustomsPoint = 7975,
    ReservationCenter = 8007,
    Station = 7976,
    Platform = 7977, // Alternative Rendering: track
    Dock = 7978,
    Depot = 7979,
    EvChargingPoint = 7980,
    InformationWelcomePoint = 7981, // Use for Tourist Information as well (D9-10)
    AtRestArea = 7982,
    AtServiceArea = 7983,
    AtWeighStation = 7984,
    RoadsidePark = 8033,
    PicnicAreas = 7985,
    RestArea = 7986,
    ServiceStations = 7987,
    Toilets = 7988, // Note also rest rooms in structures
    BusStop = 8031,
    ParkAndRideLot = 8012, // Not to be used as a mode of travel
    // Direction of Travel
    OnTheRight = 7989,
    OnTheLeft = 7990,
    InTheCenter = 7991,
    InTheOppositeDirection = 7992,
    CrossTraffic = 7993,
    NorthboundTraffic = 7994,
    EastboundTraffic = 7995,
    SouthboundTraffic = 7996,
    WestboundTraffic = 7997,
    // Compass Points
    North = 7998,
    South = 7999,
    East = 8000,
    West = 8001,
    Northeast = 8002,
    Northwest = 8003,
    Southeast = 8004,
    Southwest = 8005,
    //IncidentResponseEquipment
    GroundFireSuppression = 9985,
    HeavyGroundEquipment = 9986,
    Aircraft = 9988,
    MarineEquipment = 9989,
    SupportEquipment = 9990,
    MedicalRescueUnit = 9991,
    Other = 9993, // Deprecated by fire standards, do not use
    GroundFireSuppressionOther = 9994,
    Engine = 9995,
    TruckOrAerial = 9996,
    Quint = 9997, // A five-function type of fire apparatus. The units in the movie Backdraft were quints
    TankerPumperCombination = 9998,
    BrushTruck = 10000,
    AircraftRescueFirefighting = 10001,
    HeavyGroundEquipmentOther = 10004,
    DozerOrPlow = 10005,
    Tractor = 10006,
    TankerOrTender = 10008,
    AircraftOther = 10024,
    AircraftFixedWingTanker = 10025,
    Helitanker = 10026,
    Helicopter = 10027,
    MarineEquipmentOther = 10034,
    FireBoatWithPump = 10035,
    BoatNoPump = 10036,
    SupportApparatusOther = 10044,
    BreathingApparatusSupport = 10045,
    LightAndAirUnit = 10046,
    MedicalRescueUnitOther = 10054,
    RescueUnit = 10055,
    UrbanSearchRescueUnit = 10056,
    HighAngleRescue = 10057,
    CrashFireRescue = 10058,
    BLSUnit = 10059,
    ALSUnit = 10060,
    MobileCommandPost = 10075, // Deprecated, do not use
    ChiefOfficerCar = 10076,
    HAZMATUnit = 10077,
    TypeIHandCrew = 10078,
    TypeIIHandCrew = 10079,
    PrivatelyOwnedVehicle = 10083, // (Often found in volunteer fire teams)
    OtherApparatusResource = 10084, // (Remapped from fire code zero)
    Ambulance = 10085,
    BombSquadVan = 10086,
    CombineHarvester = 10087,
    ConstructionVehicle = 10088,
    FarmTractor = 10089,
    GrassCuttingMachines = 10090,
    HAZMATContainmentTow = 10091,
    HeavyTow = 10092,
    LightTow = 10094,
    FlatbedTow = 10114,
    HedgeCuttingMachines = 10093,
    MobileCrane = 10095,
    RefuseCollectionVehicle = 10096,
    ResurfacingVehicle = 10097,
    RoadSweeper = 10098,
    SurveyCrews = 10115,
    RoadsideLitterCollectionCrews = 10099,
    SalvageVehicle = 10100,
    SandTruck = 10101,
    Snowplow = 10102,
    SteamRoller = 10103,
    SWATTeamVan = 10104,
    TrackLayingVehicle = 10105,
    UnknownVehicle = 10106,
    WhiteLiningVehicle = 10107, // Consider using Roadwork “road marking operations” unless the objective is to refer to the specific vehicle of this type. Alternative Rendering: line painting vehicle
    DumpTruck = 10108,
    SupervisorVehicle = 10109,
    SnowBlower = 10110,
    RotarySnowBlower = 10111,
    RoadGrader = 10112, // Alternative term: motor grader
    SteamTruck = 10113,
    // IncidentResponseStatus
    UnconfirmedReport = 2817,
    InitialResponseEnRoute = 2818,
    FollowUpResponseEnRoute = 2819,
    InitialResponseOnScene = 2820,
    FollowUpResponseOnScene = 2821,
    ConfirmedReport = 2822,
    SceneIsUnsecuredAtThisTime = 2823, // Caution: This has different meanings in Public Safety use
    ResponseSceneSecured = 2824, // Caution: This has different meanings in Public Safety use
    RescueAndRecoveryWorkInProgress = 2825,
    ExtractionInProgress = 2826,
    ClearanceWorkInProgress = 2827,
    BodyRemovalOperations = 2828,
    FireContainmentContained = 2829,
    FireContainmentNotContained = 2830,
    EventCleared = 2831, // Meaning that responder has left the scene, not that surrounding traffic has cleared to a normal level
    TrafficClearing = 2832,
    IncidentClosed = 2833,
    //SystemInformation
    InformationAvailableOnRadio = 4353, // Not to be used as a default for this category D12-1
    InformationAvailableOnTV = 4354,
    CallToGetInformation = 4355,
    InformationAvailableViaInternet = 4356,
    TestMessage = 4357, // Not to be displayed on consumer devices if possible
    NoInformationAvailable = 4358, // Typically combined with “on xxx service” where xxx is a type of service (bus, rail, etc.)
    NullDescription = 4359, // (but with event location or other information provided in the message)
    PoliceAssistance = 4361,
    PoliceMonitorCB = 4362, // D12-3
    EmergencyNotification = 4363,
    InEmergencyDial911 = 4364, // D12-14
    TravelInfoCall511 = 4365, // D12-5
    CarPoolInformation = 4366, // D12-2
    InformationServiceResumed = 4478,
    // Cancel Types
    InformationServiceIsBeingSuspended = 4360,
    MessageCanceled = 4479,
    //AdviceInstructionsMandatory
    KeepToTheRight = 7425,
    KeepToTheLeft = 7426,
    UseRightLane = 7427,
    UseLeftLane = 7428,
    StayInLane = 7450,
    Merge = 7451, // Typically followed by direction left/right. Used for W4-1R and W4-1L
    HeavyVehiclesUseRightLane = 7429,
    HeavyVehiclesUseLeftLane = 7430,
    ObserveSignals = 7431,
    ObserveSigns = 7432,
    NoPassing = 7433, // Used for MUTCD signs
    NoSmoking = 7434,
    NoOpenFlames = 7435,
    UseShoulderAsLane = 7436,
    DoNotDriveOnTheShoulder = 7437,
    AllowEmergencyVehiclesToPass = 7438,
    ClearALaneForEmergencyVehicles = 7439,
    PullOverToTheEdgeOfTheRoadway = 7440,
    WaitForEscortVehicle = 7441,
    InEmergencyWaitForPolicePatrol = 7442,
    ReduceYourSpeed = 7443,
    ObserveSpeedLimits = 7444,
    CheckPoint = 7445,
    EntryRequirements = 7446,
    InsuranceRequirements = 7447,
    FirearmsRequirements = 7448,
    PetRequirements = 7449,
    SlowerTrafficKeepRight = 7452,
    KeepOff = 7453, // Typically followed by object
    EvacuateAreaImmediately = 7454,
    // Cancel Types
    ShoulderTravelNoLongerAllowed = 7547,
    //AdviceInstructionsRecommendations
    DriveCarefully = 7169,
    DriveWithExtremeCaution = 7170,
    ApproachWithCare = 7171,
    KeepYourDistance = 7172,
    IncreaseNormalFollowingDistance = 7173,
    TestYourBrakes = 7174,
    CrossIntersectionWithCare = 7175,
    PassWithCare = 7176, // Use as MUTCD sign
    Pass = 7200, // Used for passing action, as in do not pass
    UseLowBeamHeadlights = 7177,
    UseFogLights = 7178,
    UseHazardWarningLights = 7179, // Alternative Rendering: use blinkers
    DoNotLeaveYourVehicle = 7180,
    LeaveYourVehicleAndProceedToNextSafePlace = 7181,
    TurnOffEngine = 7182, // Alternative Rendering: switch off engine
    CloseAllWindowsTurnOffHeaterAirConditionerAndVents = 7183,
    TurnOffAirConditionerToPreventEngineOverheating = 7184,
    TurnOffMobilePhonesAndTwoWayRadios = 7185, // Alternative Rendering: switch off mobile phones and two-way radios
    PrepareToStop = 7186,
    BePreparedToStop = 7201,
    StopAtNextRestArea = 7187,
    StopAtNextSafePlace = 7188,
    OnlyTravelIfAbsolutelyNecessary = 7189,
    DriveToAnotherServiceArea = 7190,
    UseThroughTrafficLanes = 7191,
    UseLocalTrafficLanes = 7192,
    UseLeftHandParallelRoadway = 7193,
    UseRightHandParallelRoadway = 7194,
    UseHeavyVehicleLane = 7195, // Alternative Rendering: use truck lanes
    ObserveRecommendedSpeed = 7196,
    SignalsSequencedForSpeed = 7202, // Typically followed by speed
    MaintainTopSafeSpeed = 7203,
    FacingTraffic = 7197,
    PushButton = 7198,
    ToCrossStreet = 7199,
    EvacuateAreaVoluntarily = 7204,
    ShelterInPlace = 7205,
    // Traffic Conditions
    StoppedTraffic = 257,
    StopAndGoTraffic = 258,
    SlowTraffic = 259,
    HeavyTraffic = 260,
    TrafficBuilding = 261,
    LongQueues = 262,
    TrafficCongestion = 263,
    TrafficLighterThanNormal = 264,
    TrafficHeavierThanNormal = 265,
    TrafficMuchHeavierThanNormal = 266,
    CurrentSpeed = 267, // Typically followed by a value entry and a units entry (MPH/KPH)
    SpeedLimit = 268, // Typically followed by a value entry and a units entry (MPH/KPH)
    TravelTime = 269, // Typically followed by a value entry and a units entry (seconds)
    MergingTraffic = 272, // Typically followed by direction left/right. Can be used for W4-1R and W4-1L signs
    Contraflow = 273, // Also referred to as counter-flow
    // Cancel Types
    ContraflowCanceled = 378,
    TrafficFlowingFreely = 379,
    TrafficEasing = 380, // Alternative rendering: traffic clearing
    TrafficReturnedToNormal = 381,
    NoProblemsToReport = 382,
    TrafficCongestionCleared = 383,
    // Accidents and Incidents
    // Roadwork
    // Roads
    RoadConstruction = 1025, // Alt text: Road Work
    MajorRoadConstruction = 1026,
    LongTermRoadConstruction = 1027,
    ConstructionWork = 1028,
    PavingOperations = 1029,
    WorkInTheMedian = 1030,
    RoadReconstruction = 1031,
    OpposingTraffic = 1032,
    NarrowLanes = 1033,
    ConstructionTrafficMerging = 1034,
    SingleLineTrafficAlternatingDirections = 1035,
    RoadMaintenanceOperations = 1036,
    RoadMarkingOperations = 1037,
    RoadWidening = 1061, // Used for roadwork, not as an MUTCD sign
    Cracks = 1052, // Used for disjoint roadway surface
    CrackRemove = 1058, // No Longer Used. Used for disjoint roadway surface
    Bumps = 1053, // Used for swelling
    DropOff = 1059,
    StormDrain = 1054,
    // Bridges
    BridgeMaintenanceOperations = 1038,
    BridgeConstruction = 1039,
    BridgeDemolitionWork = 1040,
    SeismicRetrofit = 1060, // All types of earthquake construction
    // Other
    OvergrownGrass = 1055,
    OvergrownBrushShrubs = 1056,
    OvergrownTrees = 1057,
    Blasting = 1041, // See also: avalanche
    AvalancheControlActivities = 1042,
    WaterMainWork = 1043,
    GasMainWork = 1044,
    WorkOnUndergroundCables = 1045,
    WorkOnUndergroundServices = 1046,
    NewRoadConstructionLayout = 1047,
    NewRoadLayout = 1048,
    TemporaryLaneMarkings = 1049,
    TemporaryTrafficLights = 1050,
    EmergencyMaintenance = 1051,
    UtilityWork = 1062,
    // Cancel Types
    RoadMaintenanceCleared = 1146,
    NormalRoadLayoutRestored = 1147,
    RoadWorkClearanceInProgress = 1148,
    RoadConstructionCleared = 1149,
    NormalTrafficLanesRestored = 1150,
    RoadWorkCleared = 1151,
    // Obstructions
    // General
    ObstructionOnRoadway = 1281,
    ObjectOnRoadway = 1282,
    ObjectsFallingFromMovingVehicle = 1283,
    DebrisOnRoadway = 1284,
    StormDamage = 1285,
    // People
    PeopleOnRoadway = 1286,
    BicyclistsOnRoadway = 1287,
    SightseersObstructingAccess = 1288,
    LargeNumbersOfVisitors = 1289,
    // Animals
    AnimalOnRoadway = 1290,
    LargeAnimalOnRoadway = 1291,
    HerdOfAnimalsOnRoadway = 1292,
    AnimalStruck = 1293,
    // Specific Items
    AdvertisingSigns = 1315, // Used for illegal signage as well
    FallenTrees = 1294,
    OverTurnedTrees = 1311,
    TreeLimbs = 1312,
    UtilityPoleDown = 1314,
    DownedPowerLines = 1295, // Alternative Rendering: fallen power lines
    DownedCables = 1296, // Alternative Rendering: fallen cables
    Subsidence = 1297, // Alternative Rendering: road collapse
    RoadSurfaceCollapse = 1298,
    FrostJacking = 1317, // A unique Alaska problem caused by culverts or other features jacking out of ground due to freezing
    FrostHeave = 1316, // A large standing wave of soil under pavement due to frost action
    PavementBuckled = 1299,
    Pothole = 1300,
    Flooding = 1301,
    BrokenWaterMain = 1302,
    CollapsedSewer = 1303,
    WashOut = 1319, // What can happen to roads
    Washboard = 1318, // A term for rough road or unpaved roads
    SewerOverflow = 1304,
    GasLeak = 1305,
    Snowmelt = 1306, // Hint: Typically used as a cause
    Mudslide = 1307,
    Avalanche = 1308, // Possibly a disaster as well
    Rockfall = 1309,
    Landslide = 1310,
    // Cancel Types
    ClearanceWork = 1406,
    ObstructionCleared = 1407,
    // Unusual Driving
    VehicleTravelingWrongWay = 1793,
    RecklessDriver = 1794, // Alternative Rendering: erratic driver
    ProhibitedVehicleOnRoadway = 1795,
    EmergencyVehiclesOnRoadway = 1796,
    HighSpeedEmergencyVehicles = 1797,
    HighSpeedChase = 1798,
    // Cancel Types
    DangerousVehicleWarningCleared = 1918,
    EmergencyVehicleWarningCleared = 1919,
    // Mobile Situation
    AbnormalLoad = 2049,
    WideLoad = 2050,
    LongLoad = 2051,
    SlowVehicle = 2052,
    FarmEquipment = 2053,
    HorseDrawnVehicles = 2054,
    OverheightLoad = 2055,
    OverweightLoad = 2056,
    TrackedVehicle = 2057,
    VehicleCarryingHazardousMaterials = 2058,
    SlowMovingMaintenanceVehicle = 2059, // Hint: mowing, line stripping, sweepers, etc.
    Convoy = 2060,
    MilitaryConvoy = 2061,
    RefugeeConvoy = 2062,
    Motorcade = 2063,
    MobileSituationRepositioning = 2064,
    WinterMaintenanceVehicles = 2065,
    Snowplows = 2066,
    // Cancel Types
    SlowMovingMaintenanceVehicleWarningCleared = 2172,
    ExceptionalLoadWarningCleared = 2173,
    HazardousLoadWarningCleared = 2174,
    ConvoyCleared = 2175,
    // Restrictions
    Restrictions = 2561,
    RampRestrictions = 2562,
    TruckRestriction = 2563,
    SpeedRestriction = 2564, // Used for required speeds, not advised speeds
    NoiseRestriction = 2565,
    TrafficRegulationsHaveBeenChanged = 2566,
    LocalAccessOnly = 2567,
    NoTrailers = 2568,
    NoHighProfileVehicles = 2569,
    HazardousMaterialsTruckRestriction = 2570,
    NoThroughTraffic = 2571,
    NoMotorVehicles = 2572,
    WidthLimit = 2573, // Typically followed by a number and unit value
    HeightLimit = 2574, // Typically followed by a number and unit value
    LengthLimit = 2575, // Typically followed by a number and unit value
    AxleLoadLimit = 2576, // Typically followed by a number and unit value
    GrossWeightLimit = 2577, // Typically followed by a number and unit value
    AxleCountLimit = 2578, // Typically followed by a number and unit value
    CarpoolLaneAvailable = 2579,
    CarpoolRestrictionsChanged = 2580,
    HOV2NoSingleOccupantVehicles = 2581,
    HOV3NoVehiclesWithLessThanThreeOccupants = 2582,
    BusLaneAvailableForAllVehicles = 2583,
    TruckLaneAvailableForAllVehicles = 2584,
    PermitsCallInBasis = 2585,
    PermitsTemporarilyClosed = 2586,
    PermitsClosed = 2587,
    RoadUsePermitsRequired = 2588,
    // Cancel Types
    PermitsOpen = 2675,
    RestrictionsForHighProfileVehiclesLifted = 2676,
    WidthLimitLifted = 2677,
    HeightLimitLifted = 2678,
    LengthLimitLifted = 2679,
    AxleLoadLimitLifted = 2680,
    WeightLimitLifted = 2681,
    AxleCountLimitLifted = 2682,
    CarpoolRestrictionsLifted = 2683,
    LaneRestrictionsLifted = 2684,
    RampRestrictionsLifted = 2685,
    MotorVehicleRestrictionsLifted = 2686,
    RestrictionsLifted = 2687,
    // Sporting Events
    SportsEvent = 3585,
    Game = 3586,
    Tournament = 3587,
    TrackAndFieldEvent = 3588,
    BaseballGame = 3589,
    BasketballGame = 3590,
    BoxingMatch = 3591,
    FootballGame = 3592,
    SoccerGame = 3593,
    GolfTournament = 3594,
    HockeyGame = 3595,
    TennisTournament = 3596,
    WrestlingMatch = 3597,
    RoadRace = 3598, // Hint: used for motorcycle races as well
    AutomobileRace = 3599,
    BicycleRace = 3600,
    RaceEvent = 3601,
    Marathon = 3602,
    HorseShow = 3603,
    Rodeo = 3604,
    WaterSportsEvent = 3605,
    WinterSportsEvent = 3606,
    SkatingEvent = 3607,
    DogSledRace = 3608,
    // Cancel Types
    SportingEventEnded = 3711,
    // Special Events
    MajorEvent = 3841,
    Airshow = 3842,
    HotAirBallooning = 3843,
    Concert = 3844,
    StateOccasion = 3845,
    VIPVisit = 3846,
    Show = 3847,
    Festival = 3848, // Used for farmers’ markets as well
    Exhibition = 3849,
    PerformingArts = 3850,
    OutdoorMarket = 3851, // Used for farmers’ markets as well
    Fair = 3852,
    Carnival = 3853,
    FireworksDisplay = 3854,
    TradeExpo = 3855,
    MovieFilming = 3856,
    PresidentialVisit = 3857,
    Parade = 3858,
    Procession = 3859,
    FuneralProcession = 3860,
    Crowd = 3861,
    HolidayTrafficCrowds = 3862,
    // Cancel Types
    EventEnded = 3967,
    // Parking Information
    NormalParkingRestrictionsLifted = 4097, // Hint: used when a PARKING restriction is lifted (overnight parking allowed during event) Not to be used as a default for this category
    ParkingMeterRestrictionsLifted = 4098, // Hint: used when a METER restriction is lifted (metered parking free during event)
    SpecialParkingRestrictionsInForce = 4099,
    FullParkingLot = 4100,
    FullParkingGarage = 4101,
    AllParkingLotsFull = 4102,
    NoParkingSpacesAvailable = 4103,
    OnlyAFewSpacesAvailable = 4104,
    SpacesAvailable = 4105, // Typically preceded by a # value
    NoParking = 4106, // Typically followed by restriction data
    ParkingOnOneSideOfStreetOnly = 4107,
    ParkingOnBothSidesOfStreet = 4108,
    ParallelParkingOnly = 4109,
    ParkingMetersNotAvailable = 4110,
    UseOfParkingMetersRestricted = 4111,
    EventParking = 4112,
    HandicappedParking = 4113,
    LongTermParking = 4114,
    OvernightParking = 4115,
    ShortTermParking = 4116,
    ParkingByPermitOnly = 4117,
    EmergencyParkingOnly = 4118,
    EmergencyStoppingOnly = 4119,
    Parking = 4120, // Typically followed by restriction data
    Stopping = 4121, // Typically followed by restriction data
    Standing = 4122, // Typically followed by restriction data
    TowAwayZone = 4123,
    SchoolZone = 4124, // Treat as Speed Limit, with details to follow
    SpeedZone = 4125, // Treat as Speed Limit, with details to follow
    LoadingZone = 4126, // Typically followed by restriction data
    StateLaw = 4127,
    VanAccessible = 4128,
    // Cancel Types
    SpecialParkingRestrictionsLifted = 4222,
    NoParkingInformationAvailable = 4223,
    // Weather Conditions
    // General Weather
    Overcast = 4609, // This index is not to be used as a default value for this category
    Cloudy = 4610,
    MostlyCloudy = 4611,
    PartlyCloudy = 4612,
    PartlySunny = 4613,
    MostlySunny = 4614,
    Sunny = 4615,
    FairSkies = 4616,
    ClearSkies = 4617,
    MostlyClear = 4618,
    MostlyDry = 4619,
    Dry = 4620,
    UVIndexVeryHigh = 4621,
    UVIndexHigh = 4622,
    UVIndexModerate = 4623,
    UVIndexLow = 4624,
    UVIndexVeryLow = 4625,
    BarometricPressure = 4626, // Typically followed by a number and value
    OzoneAlert = 4627,
    // Lighting Types
    LightingUnknown = 4628,
    ArtificialExteriorLight = 4629,
    ArtificialInteriorLight = 4630,
    Darkness = 4631, // Also used when not lighted
    Dusk = 4632,
    Dawn = 4633,
    Moonlight = 4634,
    Daylight = 4635,
    // Cancel Types
    WeatherForecastWithdrawn = 4735,
    // Precipitation
    SevereWeather = 4865,
    Blizzard = 4866,
    HeavySnow = 4867,
    Snow = 4868,
    LightSnow = 4869,
    SnowShowers = 4870,
    WinterStorm = 4871,
    IceGlaze = 4872,
    HeavyFrost = 4873,
    Frost = 4874,
    IceStorm = 4875,
    Sleet = 4876,
    RainAndSnowMixed = 4877,
    RainChangingToSnow = 4878,
    DamagingHail = 4879,
    Hail = 4880,
    Thunderstorms = 4881,
    Thundershowers = 4882,
    ExtremelyHeavyDownpour = 4883,
    HeavyRain = 4884,
    Rain = 4885,
    LightRain = 4886,
    Drizzle = 4887,
    Showers = 4888,
    Dew = 4889,
    // Cancel Types
    PrecipitationCleared = 4991,
    // Winds
    Tornado = 5121, // Note that this can be combined with “alert” “warning” etc. This index is not to be used as a default value for this category
    Hurricane = 5122,
    HurricaneForceWinds = 5123,
    TropicalStorm = 5124,
    GaleForceWinds = 5125,
    StormForceWinds = 5126,
    StrongWinds = 5127,
    ModerateWinds = 5128,
    LightWinds = 5129,
    Calm = 5130,
    GustyWinds = 5131,
    Crosswinds = 5132,
    Windy = 5133,
    // Cancel Types
    StrongWindsHaveEased = 5246,
    StrongWindForecastWithdrawn = 5247,
    // Visibility & Air Quality
    // Visibility
    DenseFog = 5377, // This index is not to be used as a default value for this category
    Fog = 5378,
    PatchyFog = 5379,
    FreezingFog = 5380,
    IceFog = 5405, // Different than freezing fog, ice fog occurs well below freezing temps and is quite common in the Fairbanks area.
    Mist = 5381,
    Haze = 5382,
    VisibilityReduced = 5383,
    VisibilityBlocked = 5404, // Used when signs, trees, etc., block the view
    WhiteOut = 5384, // Alternative Rendering: Snow glare
    BlowingSnow = 5385,
    SmokeHazard = 5386,
    SprayHazard = 5387,
    LowSunGlare = 5388, // Do not use for snow glare
    SnowGlare = 5389,
    BlowingDust = 5390,
    BlowingSand = 5391, // Hint: dune accumulations
    DustStorms = 5392,
    Sandstorms = 5393,
    // Air Quality
    AirQualityGood = 5394,
    AirQualityFair = 5395,
    AirQualityPoor = 5396,
    AirQualityVeryPoor = 5397,
    SevereExhaustPollution = 5398,
    SmogAlert = 5399,
    PollenCountHigh = 5400,
    PollenCountMedium = 5401,
    PollenCountLow = 5402,
    SwarmsOfInsects = 5403,
    // Cancel Types
    FogClearing = 5499,
    VisibilityImproved = 5500,
    FogForecastWithdrawn = 5501,
    PollutionAlertEnded = 5502,
    AirQualityImproved = 5503,
    // Temperature
    MaximumTemperature = 5633, // This index is not to be used as a default value for this category
    Temperature = 5634, // Typically followed by a number
    MinimumTemperature = 5635,
    CurrentTemperature = 5636,
    HeatIndex = 5637,
    ExtremeHeat = 5638,
    Hot = 5639,
    Hotter = 5640,
    Heat = 5641,
    Warmer = 5642,
    Warm = 5643,
    Mild = 5644,
    Cool = 5645,
    Cooler = 5646,
    Cold = 5647,
    Colder = 5648,
    VeryCold = 5649,
    ExtremeCold = 5650,
    WindChill = 5651,
    Dewpoint = 5652,
    RelativeHumidity = 5653,
    // Cancel Types
    TemperaturesCloseToTheSeasonalNorm = 5758,
    LessExtremeTemperatures = 5759,
    // Pavement Conditions
    // General
    Impassable = 5889,
    AlmostImpassable = 5890,
    PassableWithCare = 5891,
    Passable = 5892,
    SurfaceWaterHazard = 5893,
    DangerOfHydroplaning = 5894,
    WetPavement = 5895,
    TreatedPavement = 5896, // Alternative Rendering: chemical wet
    Slippery = 5897,
    LowGroundClearance = 5938, // Use for W12-2 types
    AtGradeLevelCrossing = 5937,
    // On Roadway items
    MudOnRoadway = 5898,
    LeavesOnRoadway = 5899,
    LooseSandOnRoadway = 5900,
    LooseGravel = 5901,
    FuelOnRoadway = 5902,
    OilOnRoadway = 5903,
    RoadSurfaceInPoorCondition = 5904,
    MeltingTar = 5905,
    UnevenLanes = 5935,
    RoughRoad = 5931,
    RoughCrossing = 5936, // Typically used with grade crossings at rails
    // Ice & Snow
    Ice = 5906,
    IcyPatches = 5907,
    BlackIce = 5908,
    IcePelletsOnRoadway = 5909,
    IceBuildUp = 5910,
    FreezingRain = 5911,
    WetAndIcyRoads = 5912,
    Slush = 5914,
    MeltingSnow = 5913,
    FrozenSlush = 5915,
    SnowOnRoadway = 5916,
    PackedSnow = 5917,
    PackedSnowPatches = 5918,
    PlowedSnow = 5919,
    WetSnow = 5920,
    FreshSnow = 5921,
    PowderSnow = 5922,
    GranularSnow = 5923,
    FrozenSnow = 5924,
    CrustedSnow = 5925,
    DeepSnow = 5926,
    SnowDrifts = 5927,
    DriftingSnow = 5928,
    ExpectedSnowAccumulation = 5929,
    CurrentSnowAccumulation = 5930,
    // Road Surface
    Sand = 5932, // Can use for W7-4d
    Gravel = 5933, // Can use for W7-4e
    Paved = 5934, // Can use for W7-4f
    // Cancel Types
    DryPavement = 6011,
    SnowCleared = 6012,
    PavementConditionsImproved = 6013,
    SkidHazardReduced = 6014,
    PavementConditionsCleared = 6015,
    // Winter Driving Restrictions and Recommendations
    WinterEquipmentRecommended = 6145,
    WinterEquipmentRequired = 6146,
    SnowChainsRecommended = 6147,
    SnowChainsRequired = 6148,
    SnowChainsProhibited = 6149,
    StuddedTiresProhibited = 6150,
    SnowTiresRecommended = 6151,
    SnowTiresRequired = 6152,
    FourWheelDriveRecommended = 6153,
    FourWheelDriveRequired = 6154,
    SnowTiresOrChainsRecommended = 6155,
    SnowTiresOrChainsRequired = 6156,
    // Cancel Types
    WinterDrivingRequirementsLifted = 6271, // In early editions, this was incorrectly listed as code 6157
    // Winter Driving Index
    DrivingConditionsGood = 6401,
    DrivingConditionsFair = 6402,
    DifficultDrivingConditions = 6403,
    VeryDifficultDrivingConditions = 6404,
    HazardousDrivingConditions = 6405,
    ExtremelyHazardousDrivingConditions = 6406,
    // Suggestion Advice
    WhyNotRideShare = 6657,
    IsThisYourNoRideDay = 6658,
    WhyNotUseTransit = 6659,
    WhyNotParkAndRide = 6660,
    WhyNotTryParatransit = 6661,
    WhyNotTravelByRail = 6662,
    WhyNotUseTheSubway = 6663,
    WhyNotTryRapidTransit = 6664,
    WhyNotTravelByBus = 6665,
    YourParkingTicketCoversTheReturnRide = 6666,
    AvoidTheRushHour = 6667,
    DoNotAllowUnnecessaryGaps = 6668,
    FollowTheVehicleInFrontSmoothly = 6669,
    DoNotSlowDownUnnecessarily = 6670,
    WatchForMuggers = 6671,
    WatchForPickpockets = 6672,
    WatchForThieves = 6673,
    SorryForAnyDelay = 6674,
    ThankYouForYourUnderstanding = 6675,
    WeAppreciateYourPatience = 6676,
    WeAreGratefulForYourCooperation = 6677,
    ShareTheRoad = 6678,
    // Warning Advice
    Risk = 6913, // Conditions are more likely than “normal”
    Watch = 6914, // Conditions are favorable for an event to occur
    Warning = 6915, // An event has occurred but is not (yet) near
    Alert = 6916, // An event has occurred and it is near
    Danger = 6917,
    DangerOfExplosion = 6918,
    DangerOfFire = 6919,
    ExtraPolicePatrolsInOperation = 6920,
    LookOutForVehiclesStoppedUnderBridges = 6921,
    IncreasedRiskOfAccident = 6922,
    RescueAndRecoveryWorkInProgressAtSceneRemoved = 6923, // No longer used, see item 2825
    PoliceAtScene = 6924,
    EmergencyVehiclesAtScene = 6925,
    TrafficBeingDirectedAroundAccidentArea = 6926,
    PoliceDirectingTraffic = 6927,
    RescueWorkersDirectingTraffic = 6928,
    RepairsInProgress = 6929,
    PilotCarInOperation = 6930,
    LookOutForFlagger = 6931, // Alternative Rendering: look out for flagman
    LookOutForWorkers = 6952, // Alternative Rendering: workers
    PoliceChecksInOperation = 6932, // Hint: all types of checks
    TruckCheckPoint = 6937,
    Lockdown = 6935,
    SecurityCheckPoint = 6936,
    SingleOccupancyVehicleCheckPoint = 6938,
    MandatorySpeedLimitInForce = 6933,
    SpeedLimitInForceForHeavyVehicles = 6934,
    BehindYou = 6950,
    RideWithTraffic = 6953,
    PrepareToEvacuateArea = 6954,
    Avoid = 6955,
    // MUTCD Signs
    Look = 6939,
    PhotoEnforced = 6940,
    TrafficSigns = 6951,
    TrafficLaws = 6941,
    UseLowGear = 6942,
    BridgeIcesBeforeRoad = 6943,
    SpeedCheckedByRadar = 6944,
    SpeedCheckedByAircraft = 6945,
    Fines = 6946,
    FinesHigher = 6947,
    FinesDoubled = 6948,
    FinesTripled = 6949,
    // Cancel Types
    EvacuationCanceled = 7033,
    WarningCanceled = 7034, // Canceling a warning may “revert” to a watch
    WatchCanceled = 7035,
    AlertCanceled = 7036, // Canceling an alert may “revert” to a warning
    Ended = 7037, // Hint: used for many sporting/special events
    Cleared = 7038,
    Canceled = 7039,
    // Qualifiers
    // Locations
    Above = 7681, // Not to be used as the default for this category
    Below = 7682,
    In = 7683,
    Around = 7684,
    After = 7685,
    Before = 7686,
    At = 7687, // Hint: used in conjunction with generic locations
    On = 7688, // Hint: used in conjunction with “roadway” or other terms for both places (on-shoulder) and events (on-green)
    Near = 7689, // Hint: used with generic locations and lanes
    FromThe = 7690,
    Terminal = 7691,
    // Weather Related
    FallingSlowly = 7692,
    Falling = 7693,
    FallingQuickly = 7694,
    RisingSlowly = 7695,
    Rising = 7696,
    RisingQuickly = 7697,
    Steady = 7698,
    Likely = 7699,
    ChangingTo = 7700,
    Mostly = 7701,
    Partly = 7702,
    Minus = 7703,
    WeatherEnded = 7704,
    Expected = 7705,
    Low = 7706, // Typically used in temperatures. See also “upper”
    Mid = 7707,
    High = 7708,
    Upper = 7709, // Typically used in temperatures or broad regions. See also “low,” “mid,” “high,” “middle”
    Middle = 7765, // Typically used for broad regions. See also “upper,” “lower”
    Lower = 7764, // Typically used for broad regions. See also “upper,” “middle”
    Unseasonably = 7710,
    Reported = 7711,
    // Instructions
    Advice = 7712,
    DueTo = 7713,
    ProceedTo = 7714,
    TransferredTo = 7715,
    Use = 7716,
    // Prepositional Use
    Affecting = 7717,
    Blocking = 7718,
    Connecting = 7719,
    Finished = 7720, // Alt term: finish
    For = 7721,
    Or = 7722,
    // Other
    And = 7723,
    Later = 7724,
    Level = 7725,
    Shortly = 7726,
    Soon = 7727,
    Service = 7728,
    Graffiti = 7733,
    Damaged = 7729,
    OutOfOrder = 7730, // See Asset Status items as well
    OnStateRightOfWay = 7732,
    FoundProperty = 7734,
    Vandalism = 7731,
    Major = 7766,
    Minor = 7767,
    // MUTCD Sign Usage
    BeginTime = 7735, // Typically followed by a value entry and a time entry (AM/PM)
    Added = 7736, // Typically preceded by an object entry
    EndTime = 7737, // Typically followed by a value entry and a time entry (AM/PM)
    No = 7738, // Typically followed by a value entry and any day/time limits
    DoNot = 7739, // Also used for “does not”
    Block = 7740, // Also used for blocks
    Except = 7741, // Typically followed by a value entry and a day/time entry
    Day = 7742, // Alt: daytime, daylight hours
    Night = 7743, // Alt: night time, night time hours
    AnyTime = 7744, // Used also for “allowed”
    Has = 7745, // As in: has green (alt form: with)
    Must = 7757, // As in: <lane> must <turn>
    MayHave = 7746, // As in: may have green
    MayExceed = 7759, // As in: may exceed 80 mph
    Only = 7747,
    Lifted = 7748, // As in gate lifted
    Empty = 7749,
    Turning = 7750, // Used also for turns
    UTurn = 7751, // As in no u-turn allowed
    WaitFor = 7752,
    WhenFlashing = 7753,
    Duration = 7754, // Typically followed by a value entry and a time entry (Days/Hours/Min)
    Cross = 7755,
    WhenWet = 7756,
    Oncoming = 7758, // Typically followed by object or vehicle types
    ToRequest = 7760, // As in to request X do Y
    Exempt = 7761,
    Skewed = 7762,
    WhenChildrenArePresent = 7763, // Use for S4-2
    // Lane/Roadway Descriptions
    // Lanes
    AllRoadways = 8193, // Used as the default value
    ThroughLanes = 8194,
    LeftLane = 8195,
    RightLane = 8196,
    CenterLane = 8197,
    MiddleLanes = 8198,
    MiddleTwoLanes = 8199,
    RightTurningLanes = 8200,
    LeftTurningLanes = 8201,
    UpperDeckLanes = 8236,
    LowerDeckLanes = 8237,
    ReversibleLanes = 8238,
    RightExitLanes = 8239,
    LeftExitLanes = 8240,
    RightMergingLanes = 8241,
    LeftMergingLanes = 8242,
    // Ramps
    RightExitRamp = 8202,
    RightSecondExitRamp = 8243,
    RightEntranceRamp = 8203,
    RightSecondEntranceRamp = 8245,
    LeftExitRamp = 8204,
    LeftSecondExitRamp = 8244,
    LeftEntranceRamp = 8205,
    LeftSecondEntranceRamp = 8246,
    EscapeRamp = 8234, // A truck feature on steep downgrades common in both Alaska and elsewhere.
    // Shoulders
    HardShoulder = 8206,
    SoftShoulder = 8207,
    RightShoulder = 8208,
    LeftShoulder = 8209,
    Median = 8252,
    Sidewalk = 8251,
    // Other
    Highways = 8235,
    RightHandParallelLanes = 8210, // Alternative Rendering: right-hand frontage road
    LeftHandParallelLanes = 8211, // Alternative Rendering: left-hand frontage road
    ConnectingLanes = 8212,
    ExpressLanes = 8213,
    LocalLanes = 8214,
    TollLanes = 8215,
    ElectronicTollLanes = 8216,
    TollPlaza = 8217,
    InspectionLane = 8218, // Alternative Rendering: Border patrol inspection lane
    HOVLanes = 8219, // Use when 2+ or 3+ is unknown and for HOV in general
    BusLanes = 8220,
    CarpoolLanes = 8221,
    TruckLanes = 8222,
    EmergencyLanes = 8223,
    PassingLanes = 8224,
    ClimbingLanes = 8225,
    SlowLane = 8226, // Alternative Rendering: Crawler lane
    ServiceRoad = 8227, // Alternative Rendering: Frontage Road
    CycleLane = 8228, // Use for bicycle lanes of all types
    Tracks = 8250, // Use for light rail and transit uses, may have count of tracks
    // Bridges, Tunnels
    Bridge = 8229,
    Overpass = 8230,
    ElevatedLanes = 8231,
    Underpass = 8232,
    Tunnel = 8233, // Use for RG-200
    // Lanes Groups
    AllExitLanes = 8247,
    AllEntryLanes = 8248,
    EitherShoulder = 8249,
    ShoulderWork = 8253, // Use for W21-5 as well
    // Unit Values
    // Areas, Distances & Speeds
    SquareFeet = 8705,
    SquareMeters = 8706,
    Acres = 8707,
    Hectares = 8708,
    Inches = 8709,
    Feet = 8710,
    Mile = 8711, // Hint: used for offset as in “at mile 123” Alternative Rendering: milepost marker
    Miles = 8712, // Hint: Used for distance, as in “ending 5 miles”
    NauticalMiles = 8713,
    Millimeters = 8714,
    Meters = 8715,
    Kilometer = 8716, // Hint: used for offset as in “at kilometer 123”
    Kilometers = 8717,
    FeetPerSecond = 8718,
    MetersPerSecond = 8719,
    MPH = 8720,
    KPH = 8721,
    Knots = 8722,
    Elevation = 8766, // Typically followed by value and units
    // Times, Days & Dates
    AM = 8723, // Both a time value and a radio band value. A number value may PRECEDE the unit value used in representing the frequency of a radio station
    PM = 8724,
    Holiday = 8726,
    Seconds = 8727,
    Minutes = 8728,
    Hours = 8729,
    Days = 8730, // Hint: useful for events occurring for at least 24 hours
    Weeks = 8731,
    Months = 8732,
    OtherTimes = 8767, // Typically used to represent a “default” allowed condition
    // Days of the Week
    NSunday = 8758,
    NMonday = 8759,
    NTuesday = 8760,
    NWednesday = 8761,
    NThursday = 8762,
    NFriday = 8763,
    NSaturday = 8764,
    Weekdays = 8765, // Alt text: Mon-Fri
    Weekends = 8725, // In general date/time values can be better coded in other ways in most message sets
    // Temps, Weights, Masses and Measurements
    DegreesAngle = 8733, // Used for latitude, longitude and bearing measured clockwise from North
    DegreesCelsius = 8734, // Alternate renderings possible
    DegreesFahrenheit = 8735, // Alternate renderings possible
    Grams = 8736,
    Kilograms = 8737, // Also called a metric ton (1000kg or ~2204 lbs)
    Ounces = 8738,
    Pounds = 8739,
    Tons = 8740, // English Units (2000 lbs = 1 ton)
    FluidOunces = 8741,
    Gallons = 8742,
    Milliliters = 8743,
    Liters = 8744,
    KilogramsPerLaneMile = 8745,
    TonsPerLaneMile = 8746,
    // Misc.
    Dollar = 8747, // Alternative rendering: dollar symbol. Not to be used as the default value for this category
    Percent = 8748, // Alternative rendering: percent symbol
    Grade = 8757, // Typically preceded by a percent value entry
    TimeDelimiter = 8749, // Alternative rendering: “-”
    Dollars = 8750, // Alternative rendering can use local currency sign
    FlightNumber = 8751, // A number value may PRECEDE the unit value in use
    PersonPeople = 8752,
    ResponsePlan = 8753, // A value may PRECEDE the unit value in use (involving a combination of numbers and/or letters)
    PlacardType = 8754, // For hazmat class and division type designations, a value may PRECEDE the unit value in use
    PlacardNumber = 8755, // For chemical designations, a value may PRECEDE the unit value in use
    FM = 8756, // A number value may PRECEDE the unit value in use representing the frequency of a radio station
    // Transit Mode
    Travel = 8961, // Hint: may include all modes
    Transit = 8962, // Hint: may include all public transit modes
    Bus = 8963,
    Trolleybus = 8964,
    Rail = 8965,
    CommuterRail = 8966,
    Subway = 8967,
    RapidTransit = 8968,
    LightRail = 8969,
    Streetcar = 8970, // Alternative Rendering: tram
    DialARide = 8971, // Alternative Rendering: demand responsive transit
    ParkAndRide = 8972, // Not to be used as a place
    Shuttle = 8973,
    FreeShuttle = 8974, // Alternative Rendering: tram
    AirportShuttle = 8975,
    Taxies = 8976,
    Ferry = 8977,
    PassengerFerry = 8978,
    VehicleFerry = 8979,
    AerialTramway = 8980,
    AutomatedGuideway = 8981, // Include all types of guideways
    CableCars = 8982,
    Monorail = 8983,
    AirTravel = 8984, // All modes of air travel
    HitchHitching = 8985,
    Walk = 8986, // Alt form: Walking
    // Vehicle Groups Affected
    AllVehicles = 9217,
    Bicycles = 9218,
    Motorcycles = 9219, // to include mopeds as well
    Cars = 9220, // (remapped from ERM value of zero)
    LightVehicles = 9221,
    CarsAndLightVehicles = 9222,
    CarsWithTrailers = 9223,
    CarsWithRecreationalTrailers = 9224,
    VehiclesWithTrailers = 9225,
    HeavyVehicles = 9226,
    Trucks = 9227, // Use for RG-190
    Buses = 9228,
    ArticulatedBuses = 9229,
    SchoolBuses = 9230,
    VehiclesWithSemiTrailers = 9231,
    VehiclesWithDoubleTrailers = 9232, // Alternative Rendering: western doubles
    HighProfileVehicles = 9233,
    WideVehicles = 9234,
    LongVehicles = 9235,
    HazardousLoads = 9236,
    ExceptionalLoads = 9237,
    AbnormalLoads = 9238,
    Convoys = 9239,
    MaintenanceVehicles = 9240,
    DeliveryVehicles = 9241,
    VehiclesWithEvenNumberedLicensePlates = 9242,
    VehiclesWithOddNumberedLicensePlates = 9243,
    VehiclesWithParkingPermits = 9244,
    VehiclesWithCatalyticConverters = 9245,
    VehiclesWithoutCatalyticConverters = 9246,
    GasPoweredVehicles = 9247,
    DieselPoweredVehicles = 9248,
    LPGVehicles = 9249,
    MilitaryConvoys = 9250,
    MilitaryVehicles = 9251,
    ElectricPoweredVehicles = 9252,
    HybridPoweredVehicles = 9253,
    InherentlyLowEmissionVehicles = 9254,
    CommercialVehicles = 9255,
    RunawayVehicles = 9256,
    VehiclesWithLugs = 9257,
    MotorDrivenCycles = 9258,
    RecreationalVehicles = 9259, // Use for RVs
    NonMotorizedVehicles = 9260,
    Traffic = 9261, // Refers to all types of motor traffic, all groups
    // Traveler Group Affected
    ThroughTraffic = 9473,
    HolidayTraffic = 9474,
    Residents = 9475,
    Visitors = 9476,
    LongDistanceTraffic = 9477,
    LocalTraffic = 9478,
    RegionalTraffic = 9479,
    Arrivals = 9480,
    Departures = 9481,
    AirlineTravelers = 9482,
    CommuterAirlineTravelers = 9483,
    DomesticAirlineTravelers = 9484,
    InternationalAirlineTravelers = 9485,
    Pedestrians = 9486,
    Bicyclists = 9487, // Hint: may be used as a traveler restriction, as in “bicycles prohibited on subways during rush hour” or “road closed to bicyclists”
    // Responder Group Affected
    EmergencyVehicleUnits = 9729, // Default phrase, to be used when one of the below does not fit better
    FederalLawEnforcementUnits = 9730,
    StatePoliceUnits = 9731,
    CountyPoliceUnits = 9732, // Hint: also sheriff response units
    LocalPoliceUnits = 9733,
    AmbulanceUnits = 9734,
    RescueUnits = 9735,
    FireUnits = 9736,
    HAZMATUnits = 9737, // Any vehicle assigned to HAZMAT duties
    LightTowUnit = 9738,
    HeavyTowUnit = 9739,
    PrivateTowUnits = 9743, // For 3rd Party tow trucks
    FreewayServicePatrols = 9740,
    TransportationResponseUnits = 9741,
    PrivateContractorResponseUnits = 9742,
    // Roadside Assets
    // Inanimate Objects
    None = 10496, // Implies free text follows
    LightPole = 10497,
    UtilityPole = 10498,
    GantryWay = 10499,
    SignSupport = 10500, // All forms of signage
    SignalPole = 10501,
    SignagePublic = 10502,
    SignagePrivate = 10503,
    OverheadSign = 10568,
    GroundSign = 10569,
    Cones = 10504, // Typical std height cones as per MUTCD
    ConesPostType = 10505, // Also called channelizer cones or delineator posts
    ConesGluePost = 10506, // For all glue-down types
    ConesOther = 10507, // Specialty types or misc. smaller cones
    Barriers = 10508,
    BarrierAframe = 10509, // Sizes larger than 1.5 meters in length
    BarriersHeavyDuty = 10510, // All types requiring equipment to place
    BarricadeTypeIII = 10511, // All collapsible Type III Barricades
    BarricadeSmall = 10512, // Type I and all small A frame types, also so-called “mini” or “narrows” types
    SolidBarrier = 10565,
    MoveableBarrier = 10566,
    BarricadeLights = 10513, // Std 7” light as per ITE stds
    Beacon = 10514, // All types of strobe and rotating lights
    TStand = 10515,
    AStand = 10516,
    Drums = 10517, // Common drums and barrel types
    SandBarrel = 10567,
    ImpactAttenuator = 10518, // Water-filled and other
    BarricadeTape = 10519, // Lettering type (legend) to be conveyed elsewhere
    SafetyFence = 10520,
    TempPavementMarkings = 10521, // All forms of temp markings
    SpeedBumps = 10522, // Use also for speed humps
    TempCurbs = 10523,
    ParkingBlocks = 10524,
    SignboardFixed = 10525,
    SignboardPortable = 10526,
    Stripe = 10572,
    Island = 10573, // Used for raised islands in median
    // Controllable or Active Objects
    HAR = 10527, // Transmission type not known
    HAR_AM = 10528,
    HAR_FM = 10529,
    HAR_DSRC = 10530,
    TrafficLight = 10531, // Also used for signalized intersections
    LaneControlSignal = 10532,
    TrafficDetector = 10533,
    VehicleDetector = 10534,
    SystemAlarm = 10535,
    ArrowBoard = 10536,
    FixedVMS = 10537,
    MobileVMS = 10538,
    RampControl = 10539,
    GateControl = 10540, // Other than rail types
    TemporaryTrafficLight = 10541,
    OverHeightWarningSystem = 10542,
    OverWeightWarningSystem = 10543,
    EmergencyTelephones = 10544,
    RailroadCrossingEquipment = 10545,
    TunnelVentilation = 10546, // Use also for fans
    CCTV = 10547,
    EnvironmentalSensor = 10548,
    EmergencySignal = 10570,
    CountdownPedestrianSign = 10571,
    // Items Used by Rail and Transit
    Switch = 10549, // In the context of a railroad device
    Signal = 10550, // In the context of a railroad device
    ThirdRail = 10551,
    OverheadPower = 10552, // Specifically the power feed line for a vehicle, do not use for general power lines
    ConcreteTie = 10553,
    WoodenTie = 10554,
    ManholeCover = 10559,
    // Misc. Items
    Culvert = 10560,
    Escalator = 10555,
    Elevator = 10556,
    SnowPoles = 10561, // A tall pole and overhanging arm (like a luminaire) with reflective markers to help indicate roadway in mountain passes during whiteout conditions
    Track = 10557,
    GuidePoles = 10562, // Poles along road to indicate guard rail in deep snow
    Drawbridge = 10558,
    ExpansionJoint = 10563,
    ShiftedPlate = 10564,
    // Transit Operations
    UnknownTransitProblem = 10753,
    SleepingCustomer = 10754,
    AssaultOnPassenger = 10755,
    AssaultOnEmployee = 10756,
    BrokenSeat = 10757,
    BusAlarm = 10758,
    CrimeOrDrugDeal = 10759,
    EatingOnBoard = 10760,
    EquipmentProblemWithAirConditioning = 10761,
    EquipmentProblemWithAirSystem = 10762,
    EquipmentProblemWithBrakes = 10763,
    EquipmentProblemWithChassisOrSuspension = 10764,
    EquipmentProblemWithCoolingSystem = 10765,
    EquipmentProblemWithDoors = 10766,
    EquipmentProblemWithElectrical = 10767,
    EquipmentProblemWithEngine = 10768,
    EquipmentProblemWithExteriorOrBody = 10769,
    EquipmentProblemWithFareCollection = 10770,
    EquipmentProblemWithFuelOrExhaust = 10771,
    EquipmentProblemWithHorn = 10772,
    EquipmentProblemWithInterior = 10773,
    EquipmentProblemWithLiftKneeling = 10774,
    EquipmentProblemWithLights = 10775,
    EquipmentProblemWithLubrication = 10776,
    EquipmentProblemWithRadioOrCommunication = 10777,
    EquipmentProblemWithSigns = 10778,
    EquipmentProblemWithSteering = 10779,
    EquipmentProblemWithTires = 10780,
    EquipmentProblemWithTransmission = 10781,
    EquipmentProblemWithUnknownAlarm = 10782,
    EquipmentProblemWithWipers = 10783,
    FareDisputeExpiredPass = 10784,
    FareDisputeExpiredTransfer = 10785,
    FareDisputeExpiredUpgrade = 10786,
    FareDisputeOther = 10787,
    FareDisputeRefusesToPay = 10788,
    LiftPassengerCycleCompleted = 10789,
    LiftPassengerReadyToAlight = 10790,
    LiftPassengerReadyToBoard = 10791,
    LostArticle = 10792,
    ObjectsThrown = 10793,
    PassengerAccidentAlighting = 10794,
    PassengerAccidentBoarding = 10795,
    PassengerAccidentFallenOnBoard = 10796,
    PassengerLoad = 10797,
    PassengerAccidentOther = 10798,
    PassengerSickOrInjured = 10799,
    RightOfWay = 10800,
    Theft = 10801,
    TheftOfService = 10802,
    WaitingToGetReliefForScheduleBreak = 10803,
    WaitingToGetReliefAfterRunIsFinished = 10804,
    WaitingToProvideRelief = 10805,
    // Objects
    // Misc Items
    UnknownObject = 11009,
    Tire = 11010,
    Rim = 11011,
    Retread = 11012,
    Trash = 11013, // Consider using the CleanUpItems of IEEE 1512 for operational needs
    Cargo = 11014,
    Diesel = 11015,
    Gasoline = 11016, // RM-060
    AntiFreeze = 11017,
    PropaneGas = 11061,
    AlternativeFuel = 11060, // (Implies CNG)
    SeatBelts = 11018,
    LitterContainer = 11019, // RG-130 Alt term: Trash Container
    AllTerrainVehicle = 11020, // Rl-170
    Seaplane = 11021, // RG-260
    Chairlift = 11022, // RS-100
    FishingPier = 11023, // RW-160
    Telephone = 11025, // RM-150 See also Emergency-Telephones 10544
    RailroadCrossBuck = 11024, // (Used for Railroad crossings)
    Horn = 11048,
    Train = 11047, // The train itself regardless of the type (not the mode of transit)
    Deer = 11049, // W11-3
    Horse = 11051, // Use for equestrian as well
    Cattle = 11050, // W11-4
    GolfCart = 11052, // W11-10
    Services = 11056,
    MotoristServices = 11059, // Alt text motor services. D9-18
    FoodServices = 11053,
    RoadsideTable = 11055,
    AmbulanceStagingPoint = 11054, // Use for ambulance station as well
    // Shelters-Structures
    Fallout = 11026, // a type of shelter or structure
    Medical = 11027, // a type of shelter or structure
    Chemical = 11028, // a type of shelter or structure
    Welfare = 11029, // a type of shelter or structure
    Decontamination = 11063,
    Evacuation = 11030, // a type of shelter or structure
    Registration = 11062, // a type of shelter or structure
    Emergency = 11064, // Use only when no other type is known
    // Signal States
    LeftArrowSignal = 11031,
    AheadArrowSignal = 11032,
    RightArrowSignal = 11033,
    GreenLightSignal = 11034,
    GreenArrowSignal = 11035,
    YellowLightSignal = 11036,
    YellowArrowSignal = 11037,
    RedLightSignal = 11038,
    RedArrowSignal = 11039,
    ExtendedGreenSignal = 11040,
    AdvanceArrowSignal = 11041,
    PedestrianSignalStop = 11042, // Used for don’t walk sign
    PedestrianSignalCaution = 11043, // Used for don’t start to walk
    PedestrianSignalWalk = 11044,
    PedestrianSignalLight = 11045, // Use for light itself (regardless of state)
    PedestrianSignalTimeDisplay = 11046, // Use for count down timer display
    // Valid Maneuvers
    Prohibit_None_Allowed_LU_LT_L45_S_R45_RT_RU = 11264,
    Prohibit_RU_Allowed_LU_LT_L45_S_R45_RT = 11265, // All Maneuvers allowed
    Prohibit_RT_Allowed_LU_LT_L45_S_R45_RU = 11266,
    Prohibit_RT_RU_Allowed_LU_LT_L45_S_R45 = 11267,
    Prohibit_R45_Allowed_LU_LT_L45_S_R45_RT = 11268,
    Prohibit_R45_RU_Allowed_LU_LT_L45_S_R45_RT = 11269,
    Prohibit_R45_RT_Allowed_LU_LT_L45_S_R45_RU = 11270,
    Prohibit_R45_RT_RU_Allowed_LU_LT_L45_S = 11271, // Left or Straight Only (R3-6), Right Turn prohibited
    Prohibit_S_Allowed_LU_LT_L45_R45_RT_RU = 11272,
    Prohibit_S_RU_Allowed_LU_LT_L45_R45_RT = 11273,
    Prohibit_S_RT_Allowed_LU_LT_L45_R45_RU = 11274,
    Prohibit_S_RT_RU_Allowed_LU_LT_L45_R45 = 11275,
    Prohibit_S_R45_Allowed_LU_LT_L45_RT_RU = 11276,
    Prohibit_S_R45_RU_Allowed_LU_LT_L45_RT = 11277,
    Prohibit_S_R45_RT_Allowed_LU_LT_L45_RU = 11278,
    Prohibit_S_R45_RT_RU_Allowed_LU_LT_L45 = 11279,
    Prohibit_L45_Allowed_LU_LT_S_R45_RT_RU = 11280, // Left 45 deg turn prohibited
    Prohibit_L45_RU_Allowed_LU_LT_S_R45_RT = 11281,
    Prohibit_L45_RT_Allowed_LU_LT_S_R45_RU = 11282,
    Prohibit_L45_RT_RU_Allowed_LU_LT_S_R45 = 11283,
    Prohibit_L45_R45_Allowed_LU_LT_S_RT_RU = 11284,
    Prohibit_L45_R45_RU_Allowed_LU_LT_S_RT = 11285,
    Prohibit_L45_R45_RT_Allowed_LU_LT_S_RU = 11286,
    Prohibit_L45_R45_RT_RU_Allowed_LU_LT_S = 11287,
    Prohibit_L45_S_Allowed_LU_LT_R45_RT_RU = 11288,
    Prohibit_L45_S_RU_Allowed_LU_LT_R45_RT = 11289,
    Prohibit_L45_S_RT_Allowed_LU_LT_R45_RU = 11290,
    Prohibit_L45_S_RT_RU_Allowed_LU_LT_R45 = 11291,
    Prohibit_L45_S_R45_Allowed_LU_LT_RT_RU = 11292,
    Prohibit_L45_S_R45_RU_Allowed_LU_LT_RT_RU = 11293,
    Prohibit_L45_S_R45_RT_Allowed_LU_LT_RU = 11294,
    Prohibit_L45_S_R45_RT_RU_Allowed_LU_LT = 11295, // Left U-Turn and Left Turn Allowed
    Prohibit_LT_Allowed_LU_L45_S_R45_RT_RU = 11296, // Left Turn Prohibited (R3-2)
    Prohibit_LT_RU_Allowed_LU_L45_S_R45_RT = 11297,
    Prohibit_LT_RT_Allowed_LU_L45_S_R45_RU = 11298, // Left and Right Turn Prohibited (R3-3), Straight Only
    Prohibit_LT_RT_RU_Allowed_LU_L45_S_R45 = 11299,
    Prohibit_LT_R45_Allowed_LU_L45_S_RT = 11300,
    Prohibit_LT_R45_RU_Allowed_LU_L45_S_RT = 11301,
    Prohibit_LT_R45_RT_Allowed_LU_L45_S_RU = 11302,
    Prohibit_LT_R45_RT_RU_Allowed_LU_L45_S = 11303,
    Prohibit_LT_S_Allowed_LU_L45_R45_RT_RU = 11304, // Straight Ahead Prohibited
    Prohibit_LT_S_RU_Allowed_LU_L45_R45_RT = 11305,
    Prohibit_LT_S_RT_Allowed_LU_L45_R45_RU = 11306,
    Prohibit_LT_S_RT_RU_Allowed_LU_L45_R45 = 11307,
    Prohibit_LT_S_R45_Allowed_LU_L45_RT_RU = 11308,
    Prohibit_LT_S_R45_RU_Allowed_LU_L45_RT = 11309,
    Prohibit_LT_S_R45_RT_Allowed_LU_L45_RU = 11310,
    Prohibit_LT_S_R45_RT_RU_Allowed_LU_L45 = 11311,
    Prohibit_LT_L45_Allowed_LU_S_R45_RT_RU = 11312,
    Prohibit_LT_L45_RU_Allowed_LU_S_R45_RT = 11313,
    Prohibit_LT_L45_RT_Allowed_LU_S_R45_RU = 11314,
    Prohibit_LT_L45_RT_RU_Allowed_LU_S_R45 = 11315,
    Prohibit_LT_L45_R45_Allowed_LU_S_RT_RU = 11316,
    Prohibit_LT_L45_R45_RU_Allowed_LU_S_RT = 11317,
    Prohibit_LT_L45_R45_RT_Allowed_LU_S_RU = 11318,
    Prohibit_LT_L45_R45_RT_RU_Allowed_LU_S = 11319,
    Prohibit_LT_L45_S_Allowed_LU_R45_RT_RU = 11320,
    Prohibit_LT_L45_S_RU_Allowed_LU_R45_RT = 11321,
    Prohibit_LT_L45_S_RT_Allowed_LU_R45_RU = 11322,
    Prohibit_LT_L45_S_RT_RU_Allowed_LU_R45 = 11323,
    Prohibit_LT_L45_S_R45_Allowed_LU_RT_RU = 11324,
    Prohibit_LT_L45_S_R45_RU_Allowed_LU_RT = 11325,
    Prohibit_LT_L45_S_R45_RT_Allowed_LU_RU = 11326,
    Prohibit_LT_L45_S_R45_RT_RU_Allowed_LU = 11327, // Left U-Turn Allowed
    Prohibit_LU_Allowed_LT_L45_S_R45_RT_RU = 11328, // Left U-Turn Prohibited (R3-4)
    Prohibit_LU_RU_Allowed_LT_L45_S_R45_RT = 11329,
    Prohibit_LU_RT_Allowed_LT_L45_S_R45_RU = 11330,
    Prohibit_LU_RT_RU_Allowed_LT_L45_S_R45 = 11331,
    Prohibit_LU_R45_Allowed_LT_L45_S_RT_TRU = 11332,
    Prohibit_LU_R45_RU_Allowed_LT_L45_S_RT = 11333,
    Prohibit_LU_R45_RT_Allowed_LT_L45_S_RU = 11334,
    Prohibit_LU_R45_RT_RU_Allowed_LT_L45_S = 11335,
    Prohibit_LU_S_Allowed_LT_L45_R45_RT_RU = 11336,
    Prohibit_LU_S_RU_Allowed_LT_L45_R45_RT = 11337,
    Prohibit_LU_S_RT_Allowed_LT_L45_R45_RU = 11338,
    Prohibit_LU_S_RT_RU_Allowed_LT_L45_R45 = 11339,
    Prohibit_LU_S_R45_Allowed_LT_L45_RT_RU = 11340,
    Prohibit_LU_S_R45_RU_Allowed_LT_L45_RT = 11341,
    Prohibit_LU_S_R45_RT_Allowed_LT_L45_RU = 11342,
    Prohibit_LU_S_R45_RT_RU_Allowed_LT_L45 = 11343,
    Prohibit_LU_L45_Allowed_LT_S_R45_RT_RU = 11344,
    Prohibit_LU_L45_RU_Allowed_LT_S_R45_RT = 11345,
    Prohibit_LU_L45_RT_Allowed_LT_S_R45_RU = 11346,
    Prohibit_LU_L45_RT_RU_Allowed_LT_S_R45 = 11347,
    Prohibit_LU_L45_R45_Allowed_LT_S_RT = 11348,
    Prohibit_LU_L45_R45_RU_Allowed_LT_S_RT = 11349,
    Prohibit_LU_L45_R45_RT_Allowed_LT_S_RU = 11350,
    Prohibit_LU_L45_R45_RT_RU_Allowed_LT_S = 11351, // Left Turn and Straight Ahead Only
    Prohibit_LU_L45_S_Allowed_LT_R45_RT_RU = 11352,
    Prohibit_LU_L45_S_RU_Allowed_LT_R45_RT = 11353,
    Prohibit_LU_L45_S_RT_Allowed_LT_R45_RU = 11354,
    Prohibit_LU_L45_S_RT_RU_Allowed_LT_R45 = 11355,
    Prohibit_LU_L45_S_R45_Allowed_LT_RT_RU = 11356,
    Prohibit_LU_L45_S_R45_RU_Allowed_LT_RT = 11357, // Left Turn and Right Turn Only
    Prohibit_LU_L45_S_R45_RT_Allowed_LT_RU = 11358,
    Prohibit_LU_L45_S_R45_RT_RU_Allowed_LT = 11359, // Left Turn Only (R3-5)
    Prohibit_LU_LT_Allowed_L45_S_R45_RT_RU = 11360, // Left U-Turn and Left Turn Prohibited (R3-18)
    Prohibit_LU_LT_RU_Allowed_L45_S_R45_RT = 11361,
    Prohibit_LU_LT_RT_Allowed_L45_S_R45_RU = 11362,
    Prohibit_LU_LT_RT_RU_Allowed_L45_S_R45 = 11363,
    Prohibit_LU_LT_R45_Allowed_L45_S_RT_TRU = 11364,
    Prohibit_LU_LT_R45_RU_Allowed_L45_S_RT = 11365,
    Prohibit_LU_LT_R45_RT_Allowed_L45_S_RU = 11366,
    Prohibit_LU_LT_R45_RT_RU_Allowed_L45_S = 11367,
    Prohibit_LU_LT_S_Allowed_L45_R45_RT_RU = 11368,
    Prohibit_LU_LT_S_RU_Allowed_L45_R45_RT = 11369,
    Prohibit_LU_LT_S_RT_Allowed_L45_R45_RU = 11370,
    Prohibit_LU_LT_S_RT_RU_Allowed_L45_R45 = 11371,
    Prohibit_LU_LT_S_R45_Allowed_L45_RT_RU = 11372,
    Prohibit_LU_LT_S_R45_RU_Allowed_L45_RT = 11373,
    Prohibit_LU_LT_S_R45_RT_Allowed_L45_RU = 11374,
    Prohibit_LU_LT_S_R45_RT_RU_Allowed_L45 = 11375,
    Prohibit_LU_LT_L45_Allowed_S_R45_RT_RU = 11376, // Right Turn or Straight Only
    Prohibit_LU_LT_L45_RU_Allowed_S_R45_RT = 11377,
    Prohibit_LU_LT_L45_RT_Allowed_S_R45_RU = 11378,
    Prohibit_LU_LT_L45_RT_RU_Allowed_S_R45 = 11379,
    Prohibit_LU_LT_L45_R45_Allowed_S_RT_TRU = 11380,
    Prohibit_LU_LT_L45_R45_RU_Allowed_S_RT = 11381,
    Prohibit_LU_LT_L45_R45_RT_Allowed_S_RU = 11382,
    Prohibit_LU_LT_L45_R45_RT_RU_Allowed_S = 11383, // Straight Ahead Only (R3-5a)
    Prohibit_LU_LT_L45_S_Allowed_R45_RT_RU = 11384,
    Prohibit_LU_LT_L45_S_RU_Allowed_R45_RT = 11385,
    Prohibit_LU_LT_L45_S_RT_Allowed_R45_RU = 11386,
    Prohibit_LU_LT_L45_S_RT_RU_Allowed_R45 = 11387,
    Prohibit_LU_LT_L45_S_R45_Allowed_RT_RU = 11388,
    Prohibit_LU_LT_L45_S_R45_RU_Allowed_RT = 11389, // Right Turn Only
    Prohibit_LU_LT_L45_S_R45_RT_Allowed_RU = 11390,
    Prohibit_LU_LT_L45_S_R45_RT_RU_Allowed_None = 11391, // All Maneuvers are Prohibited
    // Large Numbers
    N116th = 11521, // The fraction 1/16th
    N110th = 11522, // The fraction 1/10th
    N18th = 11523, // The fraction 1/8th
    N14th = 11524, // The fraction 1/4th
    N13rd = 11525, // The fraction 1/3rd
    NHalf = 11526, // The fraction 1/2
    N3Qtr = 11527, // The fraction 3/4th
    N300 = 11531,
    N350 = 11532,
    N400 = 11533,
    N450 = 11534,
    N500 = 11535,
    N550 = 11536,
    N600 = 11537,
    N650 = 11538,
    N700 = 11539,
    N750 = 11540,
    N800 = 11541,
    N850 = 11542,
    N900 = 11543,
    N950 = 11544,
    N1000 = 11545,
    N1100 = 11546,
    N1200 = 11547,
    N1300 = 11548,
    N1400 = 11549,
    N1500 = 11550,
    N1600 = 11551,
    N1700 = 11552,
    N1800 = 11553,
    N1900 = 11554,
    N2000 = 11555,
    N2100 = 11556,
    N2200 = 11557,
    N2300 = 11558,
    N2400 = 11559,
    N2500 = 11560,
    N2600 = 11561,
    N2700 = 11562,
    N2800 = 11563,
    N2900 = 11564,
    N3000 = 11565,
    N3500 = 11566,
    N4000 = 11567,
    N4500 = 11568,
    N5000 = 11569,
    N5500 = 11570,
    N6000 = 11571,
    N6500 = 11572,
    N7000 = 11573,
    N7500 = 11574,
    N8000 = 11575,
    N8500 = 11576,
    N9000 = 11577,
    N9500 = 11578,
    N10000 = 11579,
    N11000 = 11580,
    N12000 = 11581,
    N13000 = 11582,
    N14000 = 11583,
    N15000 = 11584,
    N16000 = 11585,
    N17000 = 11586,
    N18000 = 11587,
    N19000 = 11588,
    N20000 = 11589,
    N21000 = 11590,
    N22000 = 11591,
    N23000 = 11592,
    N24000 = 11593,
    N25000 = 11594,
    N26000 = 11595,
    N27000 = 11596,
    N28000 = 11597,
    N29000 = 11598,
    N30000 = 11599,
    N35000 = 11600,
    N40000 = 11601,
    N45000 = 11602,
    N50000 = 11603,
    N55000 = 11604,
    N60000 = 11605,
    N65000 = 11606,
    N70000 = 11607,
    N75000 = 11608,
    N80000 = 11609,
    N85000 = 11610,
    N90000 = 11611,
    N95000 = 11612,
    N100000 = 11613,
    // Named Objects
    NameFollows = 11777, // Used for other types of named objects to delimit name
    Freeway = 11778, // Typically followed by name
    USRoute = 11779, // Typically followed by name, M1-4
    StateRoute = 11780, // Typically followed by name, M1-5
    Interstate = 11781, // Typically followed by name, M1-1
    BusinessLoop = 11782, // Typically followed by name, M1-2, M4-3
    Spur = 11797, // Typically followed by name, M1-3
    Junction = 11798, // Typically followed by names, M2-1, M2-2
    Alternative = 11783, // Typically followed by name, M4-1, M4-1a
    CountyRoute = 11784, // Typically followed by name, M1-6
    ForestRoute = 11785, // Typically followed by name, M1-7
    FarmToMarketRoute = 11786, // Typically followed by name
    EisenhowerInterstateSystem = 11787, // Typically followed by name, M1-10
    AmericasByways = 11788, // Typically followed by name, Alt term: National Scenic Byways
    NationalNetworkRoute = 11789, // Typically followed by name
    ScenicArea = 11790, // Typically followed by name
    ParkingArea = 11791, // Typically followed by name
    WeightStation = 11792, // Typically followed by name
    Road = 11793, // Typically followed by name (all types of roads and streets not otherwise listed above)
    Exit = 11794, // Typically followed by name
    HistoricalRoute = 11795, // Typically followed by name
    StateLine = 11796, // Preceded by a state name. I-2
    BicycleRoute = 11799, // Typically followed by name, M1-8
    BicycleInterstateRoute = 11800, // Typically followed by name, M1-9
    NationalPark = 11801, // Typically preceded by name, D7-1, D7-2
    // Recreational Objects and Activities
    // General Items
    BearViewingArea = 12033, // RG-020
    DeerViewingArea = 12034, // RG-040
    DrinkingWater = 12035, // RG-050
    EnvironmentalStudyArea = 12036, // RG-060
    FallingRocks = 12037, // RG-070 See also ITIS code: Rockfall 1309
    Firearms = 12038, // RG-080
    LeashedPets = 12039, // RG-110
    PointOfInterest = 12040, // RG-160
    Smoking = 12041, // RG-180
    Dog = 12042, // RG-240
    TentCamping = 12043, // RM-010
    TrailerCamping = 12044, // RM-020
    FirstAid = 12045, // RM-040
    Handicapped = 12046, // RM-080
    Mechanic = 12047, // RM-100
    TrailerSanitaryStation = 12048, // RM-160 Alt: Trailer Waste Station
    ViewingArea = 12049, // RM-170
    ScenicOverlook = 12095, // For D6-2
    Campfire = 12050, // RA-030
    Locker = 12051, // RA-070
    Sleeping = 12052, // RA-110 As in Sleeping Shelter
    Trail = 12053, // RA-120 As in Trail Shelter
    Climbing = 12054, // RL-020
    RockClimbing = 12055, // RL-030
    Hunting = 12056, // RL-040
    Playground = 12057, // RL-050
    RockCollecting = 12058, // RL-060
    Spelunking = 12059, // RL-070
    BicycleTrail = 12060, // RL-090
    HikingTrail = 12061, // RL-100
    HorseTrail = 12062, // RL-110
    TrailInterpretiveAuto = 12063, // RL-120
    TrailInterpretivePedestrian = 12064, // RL-130
    TrailRoadFor4WDVehicles = 12065, // RL-140
    TrailForTrailBikes = 12066, // RL-150
    Archer = 12067, // RL-190
    HangGlider = 12068, // RL-210
    // Water Related
    BoatTours = 12069, // RW-010
    Canoeing = 12070, // RW-020
    Diving = 12071, // RW-030
    ScubaDiving = 12072, // RW-040
    Fishing = 12073, // RW-050
    MarineRecreationArea = 12074, // RW-060
    Motorboating = 12075, // RW-070
    BoatRamp = 12076, // RW-080
    Rowboating = 12077, // RW-090
    Sailboating = 12078, // RW-100
    WaterSkiing = 12079, // RW-110
    Surfing = 12080, // RW-120
    Swimming = 12081, // RW-130
    Wading = 12082, // RW-140
    HandLaunch = 12083, // RW-170
    Kayak = 12084, // RW-190
    WindSurf = 12085, // RW-210
    // Winter-Snow Related
    IceSkating = 12086, // RS-010
    SkiJumping = 12087, // RS-020
    Bobbing = 12088, // RS-030
    CrossCountrySkiing = 12089, // RS-040
    DownhillSkiing = 12090, // RS-050
    Sledding = 12091, // RS-060
    Snowmobiling = 12092, // RS-070
    Snowshoeing = 12093, // RS-080
    WinterRecreationArea = 12094, // RS-090
    // Regulatory and Warning Signs
    // MUTCD Signage Types
    RegulatorySign = 12289, // Followed by sign data
    WarningSign = 12290, // Followed by sign data
    InformationSign = 12291, // Followed by sign data
    ConstructionSign = 12292, // Followed by sign data
    GuideSign = 12293, // Followed by sign data
    // MUTCD Basic Signs
    Stop = 12294,
    Yield = 12295,
    Caution = 12330,
    Temporary = 12331,
    ToOncomingTraffic = 12296,
    FourWay = 12297, // As in 4-way stop
    AllWay = 12298, // All directions of travel allowed or all lanes at a junction
    OneWay = 12329, // One direction of travel allowed
    // MUTCD Sign Fragments
    Zone = 12299, // Typically preceded by type of zone
    Narrows = 12300, // Used as an MUTCD sign, typically preceded by road
    Widens = 12301, // Used as an MUTCD sign, typically preceded by road
    Reduced = 12302, // Used as an MUTCD sign, typically preceded by road or lane
    Combined = 12303,
    Minimum = 12304,
    Maximum = 12305,
    DividedRoad = 12306, // Use for divided highway as well
    DoubleArrow = 12307,
    DeadEnd = 12308,
    NoOutlet = 12309,
    WrongWay = 12310, // R-5-1a
    DoNotEnter = 12314, // R-5-1
    NDetour = 12312, // Typically followed by arrows and distance
    Chevron = 12313,
    // MUTCD Intersection Graphics
    TIntersectionToTheSide = 12315,
    TIntersectionOncoming = 12316, // Use for W2-4 graphic
    YIntersectionToTheSide = 12317,
    YIntersectionOncoming = 12318, // Use for W2-5 graphic
    FourWayDividedHighwayCrossing = 12319, // Use for R6-3 graphic
    TWayDividedHighwayCrossing = 12320, // Use for R6-3a graphic
    LightRailDividedHighwayCrossing = 12321, // Use for R15-7 graphic
    LightRailTDividedHighwayCrossing = 12322, // Use for R15-7a graphic
    SideRoadToRight = 12323, // Use for W2-2R graphic
    SideRoadToLeft = 12324, // Use for W2-2L graphic
    SideRoadToRightAtAngle = 12325, // Use for W2-3R graphic
    SideRoadToLeftAtAngle = 12326, // Use for W2-3L graphic
    EnteringRoadwayMerge = 12327, // Use for W4-5 graphic
    EnteringRoadwayAddedLane = 12328, // Use for W4-6 graphic
    // Small Numbers
    N1 = 12545,
    N2 = 12546,
    N3 = 12547,
    N4 = 12548,
    N5 = 12549,
    N6 = 12550,
    N7 = 12551,
    N8 = 12552,
    N9 = 12553,
    N10 = 12554,
    N11 = 12555,
    N12 = 12556,
    N13 = 12557,
    N14 = 12558,
    N15 = 12559,
    N16 = 12560,
    N17 = 12561,
    N18 = 12562,
    N19 = 12563,
    N20 = 12564,
    N21 = 12565,
    N22 = 12566,
    N23 = 12567,
    N24 = 12568,
    N25 = 12569,
    N26 = 12570,
    N27 = 12571,
    N28 = 12572,
    N29 = 12573,
    N30 = 12574,
    N31 = 12575,
    N32 = 12576,
    N33 = 12577,
    N34 = 12578,
    N35 = 12579,
    N36 = 12580,
    N37 = 12581,
    N38 = 12582,
    N39 = 12583,
    N40 = 12584,
    N41 = 12585,
    N42 = 12586,
    N43 = 12587,
    N44 = 12588,
    N45 = 12589,
    N46 = 12590,
    N47 = 12591,
    N48 = 12592,
    N49 = 12593,
    N50 = 12594,
    N51 = 12595,
    N52 = 12596,
    N53 = 12597,
    N54 = 12598,
    N55 = 12599,
    N56 = 12600,
    N57 = 12601,
    N58 = 12602,
    N59 = 12603,
    N60 = 12604,
    N61 = 12605,
    N62 = 12606,
    N63 = 12607,
    N64 = 12608,
    N65 = 12609,
    N66 = 12610,
    N67 = 12611,
    N68 = 12612,
    N69 = 12613,
    N70 = 12614,
    N71 = 12615,
    N72 = 12616,
    N73 = 12617,
    N74 = 12618,
    N75 = 12619,
    N76 = 12620,
    N77 = 12621,
    N78 = 12622,
    N79 = 12623,
    N80 = 12624,
    N81 = 12625,
    N82 = 12626,
    N83 = 12627,
    N84 = 12628,
    N85 = 12629,
    N86 = 12630,
    N87 = 12631,
    N88 = 12632,
    N89 = 12633,
    N90 = 12634,
    N91 = 12635,
    N92 = 12636,
    N93 = 12637,
    N94 = 12638,
    N95 = 12639,
    N96 = 12640,
    N97 = 12641,
    N98 = 12642,
    N99 = 12643,
    N100 = 12644,
    N101 = 12645,
    N102 = 12646,
    N103 = 12647,
    N104 = 12648,
    N105 = 12649,
    N106 = 12650,
    N107 = 12651,
    N108 = 12652,
    N109 = 12653,
    N110 = 12654,
    N111 = 12655,
    N112 = 12656,
    N113 = 12657,
    N114 = 12658,
    N115 = 12659,
    N116 = 12660,
    N117 = 12661,
    N118 = 12662,
    N119 = 12663,
    N120 = 12664,
    N121 = 12665,
    N122 = 12666,
    N123 = 12667,
    N124 = 12668,
    N125 = 12669,
    N126 = 12670,
    N127 = 12671,
    N128 = 12672,
    N129 = 12673,
    N130 = 12674,
    N131 = 12675,
    N132 = 12676,
    N133 = 12677,
    N134 = 12678,
    N135 = 12679,
    N136 = 12680,
    N137 = 12681,
    N138 = 12682,
    N139 = 12683,
    N140 = 12684,
    N141 = 12685,
    N142 = 12686,
    N143 = 12687,
    N144 = 12688,
    N145 = 12689,
    N146 = 12690,
    N147 = 12691,
    N148 = 12692,
    N149 = 12693,
    N150 = 12694,
    N151 = 12695,
    N152 = 12696,
    N153 = 12697,
    N154 = 12698,
    N155 = 12699,
    N156 = 12700,
    N157 = 12701,
    N158 = 12702,
    N159 = 12703,
    N160 = 12704,
    N161 = 12705,
    N162 = 12706,
    N163 = 12707,
    N164 = 12708,
    N165 = 12709,
    N166 = 12710,
    N167 = 12711,
    N168 = 12712,
    N169 = 12713,
    N170 = 12714,
    N171 = 12715,
    N172 = 12716,
    N173 = 12717,
    N174 = 12718,
    N175 = 12719,
    N176 = 12720,
    N177 = 12721,
    N178 = 12722,
    N179 = 12723,
    N180 = 12724,
    N181 = 12725,
    N182 = 12726,
    N183 = 12727,
    N184 = 12728,
    N185 = 12729,
    N186 = 12730,
    N187 = 12731,
    N188 = 12732,
    N189 = 12733,
    N190 = 12734,
    N191 = 12735,
    N192 = 12736,
    N193 = 12737,
    N194 = 12738,
    N195 = 12739,
    N196 = 12740,
    N197 = 12741,
    N198 = 12742,
    N199 = 12743,
    N200 = 12744,
    N201 = 12745,
    N202 = 12746,
    N203 = 12747,
    N204 = 12748,
    N205 = 12749,
    N206 = 12750,
    N207 = 12751,
    N208 = 12752,
    N209 = 12753,
    N210 = 12754,
    N211 = 12755,
    N212 = 12756,
    N213 = 12757,
    N214 = 12758,
    N215 = 12759,
    N216 = 12760,
    N217 = 12761,
    N218 = 12762,
    N219 = 12763,
    N220 = 12764,
    N221 = 12765,
    N222 = 12766,
    N223 = 12767,
    N224 = 12768,
    N225 = 12769,
    N226 = 12770,
    N227 = 12771,
    N228 = 12772,
    N229 = 12773,
    N230 = 12774,
    N231 = 12775,
    N232 = 12776,
    N233 = 12777,
    N234 = 12778,
    N235 = 12779,
    N236 = 12780,
    N237 = 12781,
    N238 = 12782,
    N239 = 12783,
    N240 = 12784,
    N241 = 12785,
    N242 = 12786,
    N243 = 12787,
    N244 = 12788,
    N245 = 12789,
    N246 = 12790,
    N247 = 12791,
    N248 = 12792,
    N249 = 12793,
    N250 = 12794,
    N251 = 12795,
    N252 = 12796,
    N253 = 12797,
    N254 = 12798,
    N255 = 12799,
    // States and Territories
    Alabama = 12801,
    Alaska = 12802,
    AmericanSamoa = 12803,
    Arizona = 12804,
    Arkansas = 12805,
    California = 12806,
    Colorado = 12807,
    Connecticut = 12808,
    Delaware = 12809,
    DistrictOfColumbia = 12810,
    Florida = 12811,
    Georgia = 12812,
    Guam = 12813,
    Hawaii = 12814,
    Idaho = 12815,
    Illinois = 12816,
    Indiana = 12817,
    Iowa = 12818,
    Kansas = 12819,
    Kentucky = 12820,
    Louisiana = 12821,
    Maine = 12822,
    Maryland = 12823,
    Massachusetts = 12824,
    Michigan = 12825,
    Minnesota = 12826,
    Mississippi = 12827,
    Missouri = 12828,
    Montana = 12829,
    Nebraska = 12830,
    Nevada = 12831,
    NewHampshire = 12832,
    NewJersey = 12833,
    NewMexico = 12834,
    NewYork = 12835,
    NorthCarolina = 12836,
    NorthDakota = 12837,
    NorthernMarianasIslands = 12838,
    Ohio = 12839,
    Oklahoma = 12840,
    Oregon = 12841,
    Pennsylvania = 12842,
    PuertoRico = 12843,
    RhodeIsland = 12844,
    SouthCarolina = 12845,
    SouthDakota = 12846,
    Tennessee = 12847,
    Texas = 12848,
    Utah = 12849,
    Vermont = 12850,
    Virginia = 12851,
    VirginIslands = 12852,
    Washington = 12853,
    WestVirginia = 12854,
    Wisconsin = 12855,
    Wyoming = 12856,
    // Structures
    RestRoom = 13057, // RM-140
    MensRestRoom = 13058, // RA-090
    WomensRestRoom = 13059, // RA-100
    FamilyRestRoom = 13060, // RA-150
    Dam = 13061, // RG-030
    FishHatchery = 13062, // RG-090
    Information = 13063, // RG-100
    Lighthouse = 13064, // RG-120
    LookoutTower = 13065, // RG-140
    RangerStation = 13066, // RG-170
    GroceryStore = 13068, // RM-070
    Lodging = 13069, // RM-090
    PostOffice = 13070, // RM-110
    PicnicShelter = 13072, // RM-130
    GroupCamping = 13073, // RM-210
    GroupPicnicking = 13074, // RM-220
    N24HourPharmacy = 13075, // RM-230
    Kennel = 13076, // RA-050
    LaundryFacilities = 13077, // RA-060
    ShowerFacilities = 13078, // RA-130
    Amphitheater = 13079, // RL-010
    Stable = 13080, // RL-080
    Hospital = 13081, // D9-13a or D9-2
    EmergencyMedicalServicePoint = 13082, // Use for emergency medical care as well D9-13c
    Library = 13083, // I-8p
    RecyclingCollectionCenter = 13084, // I-11
    School = 13085, // Use for S1-1
    // Street Suffixes
    Alley = 13313,
    Annex = 13314,
    Arcade = 13315,
    Avenue = 13316,
    Bayou = 13317,
    Beach = 13318,
    Bend = 13319,
    Bluff = 13320,
    Bottom = 13321,
    Boulevard = 13322,
    Branch = 13323,
    NBridge = 13324, // Note use of “n” to avoid conflict with other entry
    Brook = 13325,
    Burg = 13326,
    Bypass = 13327,
    Camp = 13328,
    Canyon = 13329,
    Cape = 13330,
    Causeway = 13331,
    NCenter = 13332, // Note use of “n” to avoid conflict with other entry
    Circle = 13333,
    Cliff = 13334,
    Club = 13335,
    Common = 13336,
    Corner = 13337,
    Course = 13338,
    Court = 13339,
    Cove = 13340,
    Creek = 13341,
    Crescent = 13342,
    Crest = 13343,
    NCrossing = 13344, // Note use of “n” to avoid conflict with other entry
    Crossroad = 13345,
    Curve = 13346,
    Dale = 13347,
    NDam = 13348, // Note use of “n” to avoid conflict with other entry
    Divide = 13349,
    Drive = 13350,
    Estate = 13351,
    Expressway = 13352,
    Extension = 13353,
    Fall = 13354,
    NFerry = 13355, // Note use of “n” to avoid conflict with other entry
    Field = 13356,
    Flat = 13357,
    Ford = 13358,
    Forest = 13359,
    Forge = 13360,
    Fork = 13361,
    Fort = 13362,
    NFreeway = 13363, // Note use of “n” to avoid conflict with other entry
    Garden = 13364,
    Gateway = 13365,
    Glen = 13366,
    Green = 13367,
    Grove = 13368,
    Harbor = 13369,
    Haven = 13370,
    Heights = 13371,
    Highway = 13372,
    NHill = 13373, // Note use of “n” to avoid conflict with other entry
    Hollow = 13374,
    Inlet = 13375,
    NIsland = 13376, // Note use of “n” to avoid conflict with other entry
    Isle = 13377,
    NJunction = 13378, // Note use of “n” to avoid conflict with other entry
    Key = 13379,
    Knoll = 13380,
    Lake = 13381,
    Land = 13382,
    Landing = 13383,
    NLane = 13384, // Note use of “n” to avoid conflict with other entry
    Light = 13385,
    Loaf = 13386,
    Lock = 13387,
    Lodge = 13388,
    Loop = 13389,
    Mall = 13390,
    Manor = 13391,
    Meadow = 13392,
    Mews = 13393,
    Mill = 13394,
    Mission = 13395,
    Motorway = 13396,
    Mount = 13397,
    Mountain = 13398,
    Neck = 13399,
    Orchard = 13400,
    Oval = 13401,
    NOverpass = 13402, // Note use of “n” to avoid conflict with other entry
    Park = 13403,
    Parkway = 13404,
    NPass = 13405, // Note use of “n” to avoid conflict with other entry
    Passage = 13406,
    Path = 13407,
    Pike = 13408,
    Pine = 13409,
    Plains = 13410,
    Plaza = 13411,
    Point = 13412,
    Port = 13413,
    Prairie = 13414,
    Radial = 13415,
    Ramp = 13416,
    Ranch = 13417,
    Rapid = 13418,
    Rest = 13419,
    Ridge = 13420,
    River = 13421,
    NRoad = 13422, // Note use of “n” to avoid conflict with other entry
    Route = 13423,
    Row = 13424,
    Rue = 13425,
    Run = 13426,
    Shoal = 13427,
    Shore = 13428,
    Skyway = 13429,
    Spring = 13430,
    NSpur = 13431, // Note use of “n” to avoid conflict with other entry
    Square = 13432,
    NStation = 13433, // Note use of “n” to avoid conflict with other entry
    Stravenue = 13434,
    Stream = 13435,
    Street = 13436,
    Summit = 13437,
    Terrace = 13438,
    Throughway = 13439,
    Trace = 13440,
    NTrack = 13441, // Note use of “n” to avoid conflict with other entry
    Trafficway = 13442,
    NTrail = 13443, // Note use of “n” to avoid conflict with other entry
    NTunnel = 13444, // Note use of “n” to avoid conflict with other entry
    Turnpike = 13445,
    NUnderpass = 13446, // Note use of “n” to avoid conflict with other entry
    Union = 13447,
    Valley = 13448,
    Viaduct = 13449,
    View = 13450,
    Village = 13451,
    Ville = 13452,
    Vista = 13453,
    NWalk = 13454, // Note use of “n” to avoid conflict with other entry
    Wall = 13455,
    Way = 13456,
    Well = 13457,
    // MUTCD Locations
    // Signage Locations
    Ahead = 13569, // Location and used as arrow
    Here = 13570, // Location and used as arrow
    HereTo = 13571, // Followed by specific object
    HereToAlley = 13572,
    HereToCorner = 13573,
    HereToSign = 13574,
    BetweenSigns = 13575,
    Between = 13633, // Followed by object, and, another object
    ThisSideOfStreet = 13576,
    ThisSideOfSign = 13577,
    Right = 13579,
    Left = 13580,
    BeginPoint = 13581, // Use for “begins” as well. Do not use for times/dates
    Next = 13582, // May be followed by a distance value
    StartingStart = 13611, // Do not use for times/dates
    EndsEnd = 13583, // Do not use for times/dates
    OtherSide = 13584,
    Crossing = 13585,
    Crosswalks = 13586,
    CenterStrip = 13587, // Alt form: center stripe
    Lane = 13588, // Used for lanes as well
    Shelter = 13634, // Typically preceded by a specific type
    Center = 13635, // Typically preceded by a specific type
    // Signage Arrows
    Hill = 13589,
    BothWaysLeftAndRight = 13590,
    BothWays45DegreeAngleTiltingRight = 13591,
    BothWays45DegreeAngleTiltingLeft = 13592,
    BothDirectionsOfTravel = 13593, // As in Centerline - left turn arrows - both directions of travel or for two-way traffic
    LeftArrow = 13610,
    LeftTurn = 13594, // For W1R
    Left45DegreeArrow = 13595,
    Left45DegreeTurn = 13596,
    AheadAndToTheLeft = 13597,
    AheadAndToTheLeftAtA45DegreeAngle = 13598,
    RightArrow = 13609,
    RightTurn = 13599, // For W1R
    Right45DegreeArrow = 13600, // For W1-2
    Right45DegreeTurn = 13601,
    AheadAndToTheRight = 13602,
    AheadAndToTheRightAtA45DegreeAngle = 13603,
    DownwardLeft45Degree = 13604,
    DownwardRight45Degree = 13605,
    DownwardLeftAndRight45Degree = 13606,
    ReverseTurnToRight = 13636, // For W1-3R
    ReverseTurnToLeft = 13637, // For W1-3L
    ReverseCurveToRight = 13638, // For W1-4R
    ReverseCurveToLeft = 13639, // For W1-4L
    TwoLaneReverseCurveToRight = 13623, // For W1-4bR
    TwoLaneReverseCurveToLeft = 13624, // For W1-4bL
    ThreeLaneReverseCurveToRight = 13625, // For W1-4cR
    ThreeLaneReverseCurveToLeft = 13626, // For W1-4cL
    WindingRoadToRight = 13640, // For W1-5R
    WindingRoadToLeft = 13641, // For W1-5L
    ChevronRight = 13613, // For W1-8R
    ChevronLeft = 13614, // For W1-8L
    RightTurnWithJunction = 13615, // For horizontal alignment right W1-10R
    LeftTurnWithJunction = 13616, // For horizontal alignment left W1-10L
    HairpinRight = 13617, // For W1-11
    HairpinLeft = 13618, // For W1-11
    TruckRolloverRight = 13619, // For W1-13
    TruckRolloverLeft = 13620,
    N270DegreeTurnRight = 13621, // For W1-15
    N270DegreeTurnLeft = 13622,
    DoubleReverseCurveToRight = 13627, // For W24-1R
    DoubleReverseCurveToLeft = 13628, // For W24-1L
    TwoLaneDoubleReverseCurveToRight = 13629, // For W24-1aR
    TwoLaneDoubleReverseCurveToLeft = 13630, // For W24-1aL
    ThreeLaneDoubleReverseCurveToRight = 13631, // For W24-1bR
    ThreeLaneDoubleReverseCurveToLeft = 13632, // For W24-1bL
}
